/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type Account = {
  __typename: "Account",
  address?: string | null,
  city?: string | null,
  createdAt?: string | null,
  id: string,
  name: string,
  ownerId?: string | null,
  postalCode?: string | null,
  state?: string | null,
  updatedAt?: string | null,
  users?: ModelUserConnection | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type User = {
  __typename: "User",
  account?: Account | null,
  accountId: string,
  advisorAccess?: boolean | null,
  advisorModelId?: string | null,
  advisorPrimaryModelId?: string | null,
  cancelledOn?: string | null,
  clientOn?: string | null,
  createdAt?: string | null,
  currentModelId?: string | null,
  currentPlanId?: string | null,
  customerId?: string | null,
  deletedOn?: string | null,
  deletedReason?: string | null,
  email: string,
  emailVerified?: boolean | null,
  endDate?: string | null,
  firstName: string,
  id: string,
  lastAccess?: string | null,
  lastName: string,
  mfaPreference?: string | null,
  migrateStatus?: string | null,
  migratedOn?: string | null,
  models?: ModelModelConnection | null,
  phone?: string | null,
  phoneVerified?: boolean | null,
  primaryModelId?: string | null,
  referrer?: string | null,
  referrerDetails?: string | null,
  reviews?: ModelReviewConnection | null,
  role: UserRole,
  sessionCount?: number | null,
  sessions?: ModelSessionConnection | null,
  settings?: ModelUserSettingConnection | null,
  startDate?: string | null,
  subscribedOn?: string | null,
  trialEndDate?: string | null,
  updatedAt?: string | null,
  userStatus: UserStatus,
  userType: UserType,
};

export type ModelModelConnection = {
  __typename: "ModelModelConnection",
  items:  Array<Model | null >,
  nextToken?: string | null,
};

export type Model = {
  __typename: "Model",
  accountId: string,
  advisorCreated?: boolean | null,
  archived?: boolean | null,
  assetConversions?: ModelAssetConversionConnection | null,
  assets?: ModelAssetConnection | null,
  clientAccess?: ClientAccess | null,
  createdAt?: string | null,
  deductions?: ModelDeductionConnection | null,
  description?: string | null,
  expenses?: ModelExpenseConnection | null,
  id: string,
  incomes?: ModelIncomeConnection | null,
  liabilities?: ModelLiabilityConnection | null,
  milestones?: ModelMilestoneConnection | null,
  name: string,
  ownerId: string,
  persons?: ModelPersonConnection | null,
  plans?: ModelPlanConnection | null,
  settings?: string | null,
  snapshots?: ModelSnapshotConnection | null,
  startedAt?: string | null,
  taxValues?: ModelTaxValueConnection | null,
  taxes?: ModelTaxConnection | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  user?: User | null,
  userId: string,
};

export type ModelAssetConversionConnection = {
  __typename: "ModelAssetConversionConnection",
  items:  Array<AssetConversion | null >,
  nextToken?: string | null,
};

export type AssetConversion = {
  __typename: "AssetConversion",
  accountId: string,
  amount?: number | null,
  archived?: boolean | null,
  completedAt?: string | null,
  conversionType?: string | null,
  createdAt?: string | null,
  description?: string | null,
  dstAssetId: string,
  id: string,
  incomeType?: number | null,
  model?: Model | null,
  modelId: string,
  nonTaxableAmount?: number | null,
  percent?: number | null,
  sortOrder?: number | null,
  srcAssetId: string,
  taxableAmount?: number | null,
  updatedAt?: string | null,
  userId: string,
  year?: number | null,
};

export type ModelAssetConnection = {
  __typename: "ModelAssetConnection",
  items:  Array<Asset | null >,
  nextToken?: string | null,
};

export type Asset = {
  __typename: "Asset",
  accountId: string,
  archived?: boolean | null,
  assetCategory?: number | null,
  assetIncome?: AssetIncome | null,
  assetIncomeDate?: string | null,
  assetType?: number | null,
  balance?: number | null,
  balanceDate?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id: string,
  inheritedYear?: number | null,
  managed?: boolean | null,
  model?: Model | null,
  modelId: string,
  netWorthExcluded?: boolean | null,
  notes?: string | null,
  originalOwnerBirthYear?: number | null,
  ownerId?: string | null,
  priorEoYBalance?: number | null,
  rateLock?: boolean | null,
  returnRate?: number | null,
  risk?: number | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId: string,
  withdrawalOrder?: number | null,
  withdrawalsYTD?: number | null,
};

export type AssetIncome = {
  __typename: "AssetIncome",
  basis?: number | null,
  details?:  Array<AssetIncomeDetail | null > | null,
  rateTotal?: number | null,
  units?: number | null,
};

export type AssetIncomeDetail = {
  __typename: "AssetIncomeDetail",
  amount?: number | null,
  incomeType?: number | null,
  rate?: number | null,
};

export enum ClientAccess {
  Edit = "Edit",
  None = "None",
  Owner = "Owner",
  View = "View",
}


export type ModelDeductionConnection = {
  __typename: "ModelDeductionConnection",
  items:  Array<Deduction | null >,
  nextToken?: string | null,
};

export type Deduction = {
  __typename: "Deduction",
  accountId: string,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  deductionType?: number | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id: string,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  model?: Model | null,
  modelId: string,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelExpenseConnection = {
  __typename: "ModelExpenseConnection",
  items:  Array<Expense | null >,
  nextToken?: string | null,
};

export type Expense = {
  __typename: "Expense",
  accountId: string,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  discretionary?: boolean | null,
  end?: string | null,
  endDate?: string | null,
  expenseCategory?: number | null,
  id: string,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  liabilityId?: string | null,
  model?: Model | null,
  modelId: string,
  ownerId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelIncomeConnection = {
  __typename: "ModelIncomeConnection",
  items:  Array<Income | null >,
  nextToken?: string | null,
};

export type Income = {
  __typename: "Income",
  accountId: string,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  excludeFromNIIT?: boolean | null,
  grossAmount?: number | null,
  id: string,
  imputed?: boolean | null,
  incomeType?: number | null,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  model?: Model | null,
  modelId: string,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  survivorPercent?: number | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelLiabilityConnection = {
  __typename: "ModelLiabilityConnection",
  items:  Array<Liability | null >,
  nextToken?: string | null,
};

export type Liability = {
  __typename: "Liability",
  accountId: string,
  archived?: boolean | null,
  balance?: number | null,
  balanceDate?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id: string,
  interestRate?: number | null,
  model?: Model | null,
  modelId: string,
  ownerId?: string | null,
  payoffDate?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelMilestoneConnection = {
  __typename: "ModelMilestoneConnection",
  items:  Array<Milestone | null >,
  nextToken?: string | null,
};

export type Milestone = {
  __typename: "Milestone",
  accountId: string,
  age?: number | null,
  archived?: boolean | null,
  createdAt?: string | null,
  date?: string | null,
  description?: string | null,
  id: string,
  label?: string | null,
  model?: Model | null,
  modelId: string,
  updatedAt?: string | null,
  userId: string,
};

export type ModelPersonConnection = {
  __typename: "ModelPersonConnection",
  items:  Array<Person | null >,
  nextToken?: string | null,
};

export type Person = {
  __typename: "Person",
  accountId: string,
  birthDate?: string | null,
  createdAt?: string | null,
  gender?: Gender | null,
  hereditaryAdjust?: number | null,
  id: string,
  lifeExpectancy?: number | null,
  maritalStatus?: MaritalStatus | null,
  model?: Model | null,
  modelId: string,
  nickname?: string | null,
  retireDate?: string | null,
  state?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export enum Gender {
  Female = "Female",
  Male = "Male",
  Neutral = "Neutral",
}


export enum MaritalStatus {
  Married = "Married",
  Single = "Single",
}


export type ModelPlanConnection = {
  __typename: "ModelPlanConnection",
  items:  Array<Plan | null >,
  nextToken?: string | null,
};

export type Plan = {
  __typename: "Plan",
  accountId: string,
  archived?: boolean | null,
  changes?: ModelPlanChangeConnection | null,
  createdAt?: string | null,
  default?: boolean | null,
  description?: string | null,
  enabled?: boolean | null,
  id: string,
  model?: Model | null,
  modelId: string,
  name?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelPlanChangeConnection = {
  __typename: "ModelPlanChangeConnection",
  items:  Array<PlanChange | null >,
  nextToken?: string | null,
};

export type PlanChange = {
  __typename: "PlanChange",
  accountId: string,
  changeType: string,
  createdAt?: string | null,
  description?: string | null,
  details?: string | null,
  enabled?: boolean | null,
  id: string,
  modelId: string,
  name: string,
  plan?: Plan | null,
  planId: string,
  updatedAt?: string | null,
  userId: string,
};

export type ModelSnapshotConnection = {
  __typename: "ModelSnapshotConnection",
  items:  Array<Snapshot | null >,
  nextToken?: string | null,
};

export type Snapshot = {
  __typename: "Snapshot",
  accountId: string,
  archived?: boolean | null,
  createdAt?: string | null,
  date: string,
  description?: string | null,
  details?: string | null,
  id: string,
  model?: Model | null,
  modelId: string,
  snapshotType?: SnapshotType | null,
  updatedAt?: string | null,
  userId: string,
};

export enum SnapshotType {
  Budget = "Budget",
  Combined = "Combined",
  NetWorth = "NetWorth",
}


export type ModelTaxValueConnection = {
  __typename: "ModelTaxValueConnection",
  items:  Array<TaxValue | null >,
  nextToken?: string | null,
};

export type TaxValue = {
  __typename: "TaxValue",
  accountId: string,
  createdAt?: string | null,
  id: string,
  key: string,
  model?: Model | null,
  modelId: string,
  updatedAt?: string | null,
  userId: string,
  value: number,
  year: number,
};

export type ModelTaxConnection = {
  __typename: "ModelTaxConnection",
  items:  Array<Tax | null >,
  nextToken?: string | null,
};

export type Tax = {
  __typename: "Tax",
  accountId: string,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id: string,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  model?: Model | null,
  modelId: string,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  taxType?: number | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelReviewConnection = {
  __typename: "ModelReviewConnection",
  items:  Array<Review | null >,
  nextToken?: string | null,
};

export type Review = {
  __typename: "Review",
  accountId: string,
  archived?: boolean | null,
  baseSnapId?: string | null,
  checklist?: string | null,
  createdAt?: string | null,
  id: string,
  managed?: boolean | null,
  modelId: string,
  ownerId: string,
  reviewDate?: string | null,
  snapshotId?: string | null,
  status?: string | null,
  submittedOn?: string | null,
  updatedAt?: string | null,
  user?: User | null,
  userId: string,
};

export enum UserRole {
  Admin = "Admin",
  Advisor = "Advisor",
  Customer = "Customer",
}


export type ModelSessionConnection = {
  __typename: "ModelSessionConnection",
  items:  Array<Session | null >,
  nextToken?: string | null,
};

export type Session = {
  __typename: "Session",
  accountId: string,
  createdAt?: string | null,
  duration?: number | null,
  id: string,
  ownerId: string,
  sessionDate?: string | null,
  updatedAt?: string | null,
  user?: User | null,
  userId: string,
};

export type ModelUserSettingConnection = {
  __typename: "ModelUserSettingConnection",
  items:  Array<UserSetting | null >,
  nextToken?: string | null,
};

export type UserSetting = {
  __typename: "UserSetting",
  accountId: string,
  createdAt?: string | null,
  description?: string | null,
  id: string,
  name: string,
  ownerId: string,
  settingType?: string | null,
  settings?: string | null,
  updatedAt?: string | null,
  user?: User | null,
  userId: string,
};

export enum UserStatus {
  Active = "Active",
  Cancelled = "Cancelled",
  Created = "Created",
  Deleted = "Deleted",
  Invited = "Invited",
}


export enum UserType {
  Client = "Client",
  Free = "Free",
  Legacy = "Legacy",
  Lifetime = "Lifetime",
  Premium = "Premium",
  Trial = "Trial",
}


export type AssetCategory = {
  __typename: "AssetCategory",
  createdAt?: string | null,
  description?: string | null,
  id: string,
  sortOrder?: number | null,
  updatedAt?: string | null,
};

export type AssetType = {
  __typename: "AssetType",
  createdAt?: string | null,
  description?: string | null,
  id: string,
  updatedAt?: string | null,
};

export type ExpenseCategory = {
  __typename: "ExpenseCategory",
  createdAt?: string | null,
  description?: string | null,
  id: string,
  sortOrder?: number | null,
  updatedAt?: string | null,
};

export type IncomeType = {
  __typename: "IncomeType",
  createdAt?: string | null,
  description?: string | null,
  id: string,
  updatedAt?: string | null,
};

export type UserInvite = {
  __typename: "UserInvite",
  accountId: string,
  createdAt?: string | null,
  email: string,
  firstName: string,
  id: string,
  invitedOn: string,
  lastName: string,
  role: UserRole,
  updatedAt?: string | null,
  userId: string,
};

export type ModelAccountFilterInput = {
  address?: ModelStringInput | null,
  and?: Array< ModelAccountFilterInput | null > | null,
  city?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelAccountFilterInput | null,
  or?: Array< ModelAccountFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  postalCode?: ModelStringInput | null,
  state?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type ModelSizeInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelIDInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelAccountConnection = {
  __typename: "ModelAccountConnection",
  items:  Array<Account | null >,
  nextToken?: string | null,
};

export type ModelAssetCategoryFilterInput = {
  and?: Array< ModelAssetCategoryFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelAssetCategoryFilterInput | null,
  or?: Array< ModelAssetCategoryFilterInput | null > | null,
  sortOrder?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFloatInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelAssetCategoryConnection = {
  __typename: "ModelAssetCategoryConnection",
  items:  Array<AssetCategory | null >,
  nextToken?: string | null,
};

export type ModelAssetConversionFilterInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  and?: Array< ModelAssetConversionFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  completedAt?: ModelStringInput | null,
  conversionType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  dstAssetId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  incomeType?: ModelIntInput | null,
  modelId?: ModelIDInput | null,
  nonTaxableAmount?: ModelIntInput | null,
  not?: ModelAssetConversionFilterInput | null,
  or?: Array< ModelAssetConversionFilterInput | null > | null,
  percent?: ModelFloatInput | null,
  sortOrder?: ModelFloatInput | null,
  srcAssetId?: ModelIDInput | null,
  taxableAmount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  year?: ModelIntInput | null,
};

export type ModelIntInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelBooleanInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  eq?: boolean | null,
  ne?: boolean | null,
};

export type ModelAssetTypeFilterInput = {
  and?: Array< ModelAssetTypeFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelAssetTypeFilterInput | null,
  or?: Array< ModelAssetTypeFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAssetTypeConnection = {
  __typename: "ModelAssetTypeConnection",
  items:  Array<AssetType | null >,
  nextToken?: string | null,
};

export type ModelAssetFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelAssetFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  assetCategory?: ModelIntInput | null,
  assetIncomeDate?: ModelStringInput | null,
  assetType?: ModelIntInput | null,
  balance?: ModelIntInput | null,
  balanceDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  inheritedYear?: ModelIntInput | null,
  managed?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  netWorthExcluded?: ModelBooleanInput | null,
  not?: ModelAssetFilterInput | null,
  notes?: ModelStringInput | null,
  or?: Array< ModelAssetFilterInput | null > | null,
  originalOwnerBirthYear?: ModelIntInput | null,
  ownerId?: ModelIDInput | null,
  priorEoYBalance?: ModelIntInput | null,
  rateLock?: ModelBooleanInput | null,
  returnRate?: ModelFloatInput | null,
  risk?: ModelIntInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  withdrawalOrder?: ModelIntInput | null,
  withdrawalsYTD?: ModelIntInput | null,
};

export type ModelPlanChangeFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelPlanChangeFilterInput | null > | null,
  changeType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  details?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelPlanChangeFilterInput | null,
  or?: Array< ModelPlanChangeFilterInput | null > | null,
  planId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelDeductionFilterInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  amountDate?: ModelStringInput | null,
  and?: Array< ModelDeductionFilterInput | null > | null,
  annualInf?: ModelFloatInput | null,
  archived?: ModelBooleanInput | null,
  assetId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  deductionType?: ModelIntInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  infAdjust?: ModelBooleanInput | null,
  infLock?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelDeductionFilterInput | null,
  or?: Array< ModelDeductionFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  paycheckId?: ModelIDInput | null,
  schedule?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelExpenseCategoryFilterInput = {
  and?: Array< ModelExpenseCategoryFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelExpenseCategoryFilterInput | null,
  or?: Array< ModelExpenseCategoryFilterInput | null > | null,
  sortOrder?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelExpenseCategoryConnection = {
  __typename: "ModelExpenseCategoryConnection",
  items:  Array<ExpenseCategory | null >,
  nextToken?: string | null,
};

export type ModelExpenseFilterInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  amountDate?: ModelStringInput | null,
  and?: Array< ModelExpenseFilterInput | null > | null,
  annualInf?: ModelFloatInput | null,
  archived?: ModelBooleanInput | null,
  assetId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  discretionary?: ModelBooleanInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  expenseCategory?: ModelIntInput | null,
  id?: ModelIDInput | null,
  infAdjust?: ModelBooleanInput | null,
  infLock?: ModelBooleanInput | null,
  liabilityId?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelExpenseFilterInput | null,
  or?: Array< ModelExpenseFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  schedule?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelIncomeTypeFilterInput = {
  and?: Array< ModelIncomeTypeFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelIncomeTypeFilterInput | null,
  or?: Array< ModelIncomeTypeFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIncomeTypeConnection = {
  __typename: "ModelIncomeTypeConnection",
  items:  Array<IncomeType | null >,
  nextToken?: string | null,
};

export type ModelIncomeFilterInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  amountDate?: ModelStringInput | null,
  and?: Array< ModelIncomeFilterInput | null > | null,
  annualInf?: ModelFloatInput | null,
  archived?: ModelBooleanInput | null,
  assetId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  excludeFromNIIT?: ModelBooleanInput | null,
  grossAmount?: ModelIntInput | null,
  id?: ModelIDInput | null,
  imputed?: ModelBooleanInput | null,
  incomeType?: ModelIntInput | null,
  infAdjust?: ModelBooleanInput | null,
  infLock?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelIncomeFilterInput | null,
  or?: Array< ModelIncomeFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  paycheckId?: ModelIDInput | null,
  schedule?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  survivorPercent?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelLiabilityFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelLiabilityFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  balance?: ModelIntInput | null,
  balanceDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  interestRate?: ModelFloatInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelLiabilityFilterInput | null,
  or?: Array< ModelLiabilityFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  payoffDate?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelMilestoneFilterInput = {
  accountId?: ModelIDInput | null,
  age?: ModelIntInput | null,
  and?: Array< ModelMilestoneFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  label?: ModelStringInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelMilestoneFilterInput | null,
  or?: Array< ModelMilestoneFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelModelFilterInput = {
  accountId?: ModelIDInput | null,
  advisorCreated?: ModelBooleanInput | null,
  and?: Array< ModelModelFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  clientAccess?: ModelClientAccessInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelModelFilterInput | null,
  or?: Array< ModelModelFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  settings?: ModelStringInput | null,
  startedAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelClientAccessInput = {
  eq?: ClientAccess | null,
  ne?: ClientAccess | null,
};

export type ModelPersonFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelPersonFilterInput | null > | null,
  birthDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  gender?: ModelGenderInput | null,
  hereditaryAdjust?: ModelIntInput | null,
  id?: ModelIDInput | null,
  lifeExpectancy?: ModelIntInput | null,
  maritalStatus?: ModelMaritalStatusInput | null,
  modelId?: ModelIDInput | null,
  nickname?: ModelStringInput | null,
  not?: ModelPersonFilterInput | null,
  or?: Array< ModelPersonFilterInput | null > | null,
  retireDate?: ModelStringInput | null,
  state?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelGenderInput = {
  eq?: Gender | null,
  ne?: Gender | null,
};

export type ModelMaritalStatusInput = {
  eq?: MaritalStatus | null,
  ne?: MaritalStatus | null,
};

export type ModelPlanFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelPlanFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelPlanFilterInput | null,
  or?: Array< ModelPlanFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelReviewFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelReviewFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  baseSnapId?: ModelIDInput | null,
  checklist?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  managed?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelReviewFilterInput | null,
  or?: Array< ModelReviewFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  reviewDate?: ModelStringInput | null,
  snapshotId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  submittedOn?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelSessionFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelSessionFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  id?: ModelIDInput | null,
  not?: ModelSessionFilterInput | null,
  or?: Array< ModelSessionFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  sessionDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelStringKeyConditionInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
};

export type ModelSnapshotFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelSnapshotFilterInput | null > | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  description?: ModelStringInput | null,
  details?: ModelStringInput | null,
  id?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelSnapshotFilterInput | null,
  or?: Array< ModelSnapshotFilterInput | null > | null,
  snapshotType?: ModelSnapshotTypeInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelSnapshotTypeInput = {
  eq?: SnapshotType | null,
  ne?: SnapshotType | null,
};

export type ModelTaxValueFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelTaxValueFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  key?: ModelStringInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelTaxValueFilterInput | null,
  or?: Array< ModelTaxValueFilterInput | null > | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  value?: ModelFloatInput | null,
  year?: ModelIntInput | null,
};

export type ModelIntKeyConditionInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
};

export type ModelTaxFilterInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  amountDate?: ModelStringInput | null,
  and?: Array< ModelTaxFilterInput | null > | null,
  annualInf?: ModelFloatInput | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  infAdjust?: ModelBooleanInput | null,
  infLock?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelTaxFilterInput | null,
  or?: Array< ModelTaxFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  paycheckId?: ModelIDInput | null,
  schedule?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  taxType?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelUserInviteFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelUserInviteFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  invitedOn?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  not?: ModelUserInviteFilterInput | null,
  or?: Array< ModelUserInviteFilterInput | null > | null,
  role?: ModelUserRoleInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelUserRoleInput = {
  eq?: UserRole | null,
  ne?: UserRole | null,
};

export type ModelUserInviteConnection = {
  __typename: "ModelUserInviteConnection",
  items:  Array<UserInvite | null >,
  nextToken?: string | null,
};

export type ModelUserSettingFilterInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelUserSettingFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelUserSettingFilterInput | null,
  or?: Array< ModelUserSettingFilterInput | null > | null,
  ownerId?: ModelIDInput | null,
  settingType?: ModelStringInput | null,
  settings?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelUserFilterInput = {
  accountId?: ModelIDInput | null,
  advisorAccess?: ModelBooleanInput | null,
  advisorModelId?: ModelIDInput | null,
  advisorPrimaryModelId?: ModelIDInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  cancelledOn?: ModelStringInput | null,
  clientOn?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  currentModelId?: ModelIDInput | null,
  currentPlanId?: ModelIDInput | null,
  customerId?: ModelStringInput | null,
  deletedOn?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  email?: ModelStringInput | null,
  emailVerified?: ModelBooleanInput | null,
  endDate?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  lastAccess?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  mfaPreference?: ModelStringInput | null,
  migrateStatus?: ModelStringInput | null,
  migratedOn?: ModelStringInput | null,
  not?: ModelUserFilterInput | null,
  or?: Array< ModelUserFilterInput | null > | null,
  phone?: ModelStringInput | null,
  phoneVerified?: ModelBooleanInput | null,
  primaryModelId?: ModelIDInput | null,
  referrer?: ModelStringInput | null,
  referrerDetails?: ModelStringInput | null,
  role?: ModelUserRoleInput | null,
  sessionCount?: ModelIntInput | null,
  startDate?: ModelStringInput | null,
  subscribedOn?: ModelStringInput | null,
  trialEndDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userStatus?: ModelUserStatusInput | null,
  userType?: ModelUserTypeInput | null,
};

export type ModelUserStatusInput = {
  eq?: UserStatus | null,
  ne?: UserStatus | null,
};

export type ModelUserTypeInput = {
  eq?: UserType | null,
  ne?: UserType | null,
};

export type ModelAccountConditionInput = {
  address?: ModelStringInput | null,
  and?: Array< ModelAccountConditionInput | null > | null,
  city?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelAccountConditionInput | null,
  or?: Array< ModelAccountConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  postalCode?: ModelStringInput | null,
  state?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateAccountInput = {
  address?: string | null,
  city?: string | null,
  createdAt?: string | null,
  id?: string | null,
  name: string,
  ownerId?: string | null,
  postalCode?: string | null,
  state?: string | null,
  updatedAt?: string | null,
};

export type ModelAssetConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelAssetConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  assetCategory?: ModelIntInput | null,
  assetIncomeDate?: ModelStringInput | null,
  assetType?: ModelIntInput | null,
  balance?: ModelIntInput | null,
  balanceDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  inheritedYear?: ModelIntInput | null,
  managed?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  netWorthExcluded?: ModelBooleanInput | null,
  not?: ModelAssetConditionInput | null,
  notes?: ModelStringInput | null,
  or?: Array< ModelAssetConditionInput | null > | null,
  originalOwnerBirthYear?: ModelIntInput | null,
  ownerId?: ModelIDInput | null,
  priorEoYBalance?: ModelIntInput | null,
  rateLock?: ModelBooleanInput | null,
  returnRate?: ModelFloatInput | null,
  risk?: ModelIntInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  withdrawalOrder?: ModelIntInput | null,
  withdrawalsYTD?: ModelIntInput | null,
};

export type CreateAssetInput = {
  accountId: string,
  archived?: boolean | null,
  assetCategory?: number | null,
  assetIncome?: AssetIncomeInput | null,
  assetIncomeDate?: string | null,
  assetType?: number | null,
  balance?: number | null,
  balanceDate?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id?: string | null,
  inheritedYear?: number | null,
  managed?: boolean | null,
  modelId: string,
  netWorthExcluded?: boolean | null,
  notes?: string | null,
  originalOwnerBirthYear?: number | null,
  ownerId?: string | null,
  priorEoYBalance?: number | null,
  rateLock?: boolean | null,
  returnRate?: number | null,
  risk?: number | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId: string,
  withdrawalOrder?: number | null,
  withdrawalsYTD?: number | null,
};

export type AssetIncomeInput = {
  basis?: number | null,
  details?: Array< AssetIncomeDetailInput | null > | null,
  rateTotal?: number | null,
  units?: number | null,
};

export type AssetIncomeDetailInput = {
  amount?: number | null,
  incomeType?: number | null,
  rate?: number | null,
};

export type ModelAssetCategoryConditionInput = {
  and?: Array< ModelAssetCategoryConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  not?: ModelAssetCategoryConditionInput | null,
  or?: Array< ModelAssetCategoryConditionInput | null > | null,
  sortOrder?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateAssetCategoryInput = {
  createdAt?: string | null,
  description?: string | null,
  id?: string | null,
  sortOrder?: number | null,
  updatedAt?: string | null,
};

export type ModelAssetConversionConditionInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  and?: Array< ModelAssetConversionConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  completedAt?: ModelStringInput | null,
  conversionType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  dstAssetId?: ModelIDInput | null,
  incomeType?: ModelIntInput | null,
  modelId?: ModelIDInput | null,
  nonTaxableAmount?: ModelIntInput | null,
  not?: ModelAssetConversionConditionInput | null,
  or?: Array< ModelAssetConversionConditionInput | null > | null,
  percent?: ModelFloatInput | null,
  sortOrder?: ModelFloatInput | null,
  srcAssetId?: ModelIDInput | null,
  taxableAmount?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  year?: ModelIntInput | null,
};

export type CreateAssetConversionInput = {
  accountId: string,
  amount?: number | null,
  archived?: boolean | null,
  completedAt?: string | null,
  conversionType?: string | null,
  createdAt?: string | null,
  description?: string | null,
  dstAssetId: string,
  id?: string | null,
  incomeType?: number | null,
  modelId: string,
  nonTaxableAmount?: number | null,
  percent?: number | null,
  sortOrder?: number | null,
  srcAssetId: string,
  taxableAmount?: number | null,
  updatedAt?: string | null,
  userId: string,
  year?: number | null,
};

export type ModelAssetTypeConditionInput = {
  and?: Array< ModelAssetTypeConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  not?: ModelAssetTypeConditionInput | null,
  or?: Array< ModelAssetTypeConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateAssetTypeInput = {
  createdAt?: string | null,
  description?: string | null,
  id?: string | null,
  updatedAt?: string | null,
};

export type ModelDeductionConditionInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  amountDate?: ModelStringInput | null,
  and?: Array< ModelDeductionConditionInput | null > | null,
  annualInf?: ModelFloatInput | null,
  archived?: ModelBooleanInput | null,
  assetId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  deductionType?: ModelIntInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  infAdjust?: ModelBooleanInput | null,
  infLock?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelDeductionConditionInput | null,
  or?: Array< ModelDeductionConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  paycheckId?: ModelIDInput | null,
  schedule?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateDeductionInput = {
  accountId: string,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  deductionType?: number | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id?: string | null,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  modelId: string,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelExpenseConditionInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  amountDate?: ModelStringInput | null,
  and?: Array< ModelExpenseConditionInput | null > | null,
  annualInf?: ModelFloatInput | null,
  archived?: ModelBooleanInput | null,
  assetId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  discretionary?: ModelBooleanInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  expenseCategory?: ModelIntInput | null,
  infAdjust?: ModelBooleanInput | null,
  infLock?: ModelBooleanInput | null,
  liabilityId?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelExpenseConditionInput | null,
  or?: Array< ModelExpenseConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  schedule?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateExpenseInput = {
  accountId: string,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  discretionary?: boolean | null,
  end?: string | null,
  endDate?: string | null,
  expenseCategory?: number | null,
  id?: string | null,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  liabilityId?: string | null,
  modelId: string,
  ownerId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelExpenseCategoryConditionInput = {
  and?: Array< ModelExpenseCategoryConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  not?: ModelExpenseCategoryConditionInput | null,
  or?: Array< ModelExpenseCategoryConditionInput | null > | null,
  sortOrder?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateExpenseCategoryInput = {
  createdAt?: string | null,
  description?: string | null,
  id?: string | null,
  sortOrder?: number | null,
  updatedAt?: string | null,
};

export type ModelIncomeConditionInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  amountDate?: ModelStringInput | null,
  and?: Array< ModelIncomeConditionInput | null > | null,
  annualInf?: ModelFloatInput | null,
  archived?: ModelBooleanInput | null,
  assetId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  excludeFromNIIT?: ModelBooleanInput | null,
  grossAmount?: ModelIntInput | null,
  imputed?: ModelBooleanInput | null,
  incomeType?: ModelIntInput | null,
  infAdjust?: ModelBooleanInput | null,
  infLock?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelIncomeConditionInput | null,
  or?: Array< ModelIncomeConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  paycheckId?: ModelIDInput | null,
  schedule?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  survivorPercent?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateIncomeInput = {
  accountId: string,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  excludeFromNIIT?: boolean | null,
  grossAmount?: number | null,
  id?: string | null,
  imputed?: boolean | null,
  incomeType?: number | null,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  modelId: string,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  survivorPercent?: number | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelIncomeTypeConditionInput = {
  and?: Array< ModelIncomeTypeConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  not?: ModelIncomeTypeConditionInput | null,
  or?: Array< ModelIncomeTypeConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateIncomeTypeInput = {
  createdAt?: string | null,
  description?: string | null,
  id?: string | null,
  updatedAt?: string | null,
};

export type ModelLiabilityConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelLiabilityConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  balance?: ModelIntInput | null,
  balanceDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  interestRate?: ModelFloatInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelLiabilityConditionInput | null,
  or?: Array< ModelLiabilityConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  payoffDate?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateLiabilityInput = {
  accountId: string,
  archived?: boolean | null,
  balance?: number | null,
  balanceDate?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id?: string | null,
  interestRate?: number | null,
  modelId: string,
  ownerId?: string | null,
  payoffDate?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelMilestoneConditionInput = {
  accountId?: ModelIDInput | null,
  age?: ModelIntInput | null,
  and?: Array< ModelMilestoneConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  description?: ModelStringInput | null,
  label?: ModelStringInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelMilestoneConditionInput | null,
  or?: Array< ModelMilestoneConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateMilestoneInput = {
  accountId: string,
  age?: number | null,
  archived?: boolean | null,
  createdAt?: string | null,
  date?: string | null,
  description?: string | null,
  id?: string | null,
  label?: string | null,
  modelId: string,
  updatedAt?: string | null,
  userId: string,
};

export type ModelModelConditionInput = {
  accountId?: ModelIDInput | null,
  advisorCreated?: ModelBooleanInput | null,
  and?: Array< ModelModelConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  clientAccess?: ModelClientAccessInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelModelConditionInput | null,
  or?: Array< ModelModelConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  settings?: ModelStringInput | null,
  startedAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateModelInput = {
  accountId: string,
  advisorCreated?: boolean | null,
  archived?: boolean | null,
  clientAccess?: ClientAccess | null,
  createdAt?: string | null,
  description?: string | null,
  id?: string | null,
  name: string,
  ownerId: string,
  settings?: string | null,
  startedAt?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  userId: string,
};

export type ModelPersonConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelPersonConditionInput | null > | null,
  birthDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  gender?: ModelGenderInput | null,
  hereditaryAdjust?: ModelIntInput | null,
  lifeExpectancy?: ModelIntInput | null,
  maritalStatus?: ModelMaritalStatusInput | null,
  modelId?: ModelIDInput | null,
  nickname?: ModelStringInput | null,
  not?: ModelPersonConditionInput | null,
  or?: Array< ModelPersonConditionInput | null > | null,
  retireDate?: ModelStringInput | null,
  state?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreatePersonInput = {
  accountId: string,
  birthDate?: string | null,
  createdAt?: string | null,
  gender?: Gender | null,
  hereditaryAdjust?: number | null,
  id?: string | null,
  lifeExpectancy?: number | null,
  maritalStatus?: MaritalStatus | null,
  modelId: string,
  nickname?: string | null,
  retireDate?: string | null,
  state?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelPlanConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelPlanConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelPlanConditionInput | null,
  or?: Array< ModelPlanConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreatePlanInput = {
  accountId: string,
  archived?: boolean | null,
  createdAt?: string | null,
  default?: boolean | null,
  description?: string | null,
  enabled?: boolean | null,
  id?: string | null,
  modelId: string,
  name?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelPlanChangeConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelPlanChangeConditionInput | null > | null,
  changeType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  details?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelPlanChangeConditionInput | null,
  or?: Array< ModelPlanChangeConditionInput | null > | null,
  planId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreatePlanChangeInput = {
  accountId: string,
  changeType: string,
  createdAt?: string | null,
  description?: string | null,
  details?: string | null,
  enabled?: boolean | null,
  id?: string | null,
  modelId: string,
  name: string,
  planId: string,
  updatedAt?: string | null,
  userId: string,
};

export type ModelReviewConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelReviewConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  baseSnapId?: ModelIDInput | null,
  checklist?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  managed?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelReviewConditionInput | null,
  or?: Array< ModelReviewConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  reviewDate?: ModelStringInput | null,
  snapshotId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  submittedOn?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateReviewInput = {
  accountId: string,
  archived?: boolean | null,
  baseSnapId?: string | null,
  checklist?: string | null,
  createdAt?: string | null,
  id?: string | null,
  managed?: boolean | null,
  modelId: string,
  ownerId: string,
  reviewDate?: string | null,
  snapshotId?: string | null,
  status?: string | null,
  submittedOn?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelSessionConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelSessionConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  not?: ModelSessionConditionInput | null,
  or?: Array< ModelSessionConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  sessionDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateSessionInput = {
  accountId: string,
  createdAt?: string | null,
  duration?: number | null,
  id?: string | null,
  ownerId: string,
  sessionDate?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelSnapshotConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelSnapshotConditionInput | null > | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  date?: ModelStringInput | null,
  description?: ModelStringInput | null,
  details?: ModelStringInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelSnapshotConditionInput | null,
  or?: Array< ModelSnapshotConditionInput | null > | null,
  snapshotType?: ModelSnapshotTypeInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateSnapshotInput = {
  accountId: string,
  archived?: boolean | null,
  createdAt?: string | null,
  date: string,
  description?: string | null,
  details?: string | null,
  id?: string | null,
  modelId: string,
  snapshotType?: SnapshotType | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelTaxConditionInput = {
  accountId?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  amountDate?: ModelStringInput | null,
  and?: Array< ModelTaxConditionInput | null > | null,
  annualInf?: ModelFloatInput | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  end?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  infAdjust?: ModelBooleanInput | null,
  infLock?: ModelBooleanInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelTaxConditionInput | null,
  or?: Array< ModelTaxConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  paycheckId?: ModelIDInput | null,
  schedule?: ModelStringInput | null,
  sortOrder?: ModelFloatInput | null,
  start?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  taxType?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateTaxInput = {
  accountId: string,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id?: string | null,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  modelId: string,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  taxType?: number | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelTaxValueConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelTaxValueConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  key?: ModelStringInput | null,
  modelId?: ModelIDInput | null,
  not?: ModelTaxValueConditionInput | null,
  or?: Array< ModelTaxValueConditionInput | null > | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  value?: ModelFloatInput | null,
  year?: ModelIntInput | null,
};

export type CreateTaxValueInput = {
  accountId: string,
  createdAt?: string | null,
  id?: string | null,
  key: string,
  modelId: string,
  updatedAt?: string | null,
  userId: string,
  value: number,
  year: number,
};

export type ModelUserConditionInput = {
  accountId?: ModelIDInput | null,
  advisorAccess?: ModelBooleanInput | null,
  advisorModelId?: ModelIDInput | null,
  advisorPrimaryModelId?: ModelIDInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  cancelledOn?: ModelStringInput | null,
  clientOn?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  currentModelId?: ModelIDInput | null,
  currentPlanId?: ModelIDInput | null,
  customerId?: ModelStringInput | null,
  deletedOn?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  email?: ModelStringInput | null,
  emailVerified?: ModelBooleanInput | null,
  endDate?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  id?: ModelStringInput | null,
  lastAccess?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  mfaPreference?: ModelStringInput | null,
  migrateStatus?: ModelStringInput | null,
  migratedOn?: ModelStringInput | null,
  not?: ModelUserConditionInput | null,
  or?: Array< ModelUserConditionInput | null > | null,
  phone?: ModelStringInput | null,
  phoneVerified?: ModelBooleanInput | null,
  primaryModelId?: ModelIDInput | null,
  referrer?: ModelStringInput | null,
  referrerDetails?: ModelStringInput | null,
  role?: ModelUserRoleInput | null,
  sessionCount?: ModelIntInput | null,
  startDate?: ModelStringInput | null,
  subscribedOn?: ModelStringInput | null,
  trialEndDate?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userStatus?: ModelUserStatusInput | null,
  userType?: ModelUserTypeInput | null,
};

export type CreateUserInput = {
  accountId: string,
  advisorAccess?: boolean | null,
  advisorModelId?: string | null,
  advisorPrimaryModelId?: string | null,
  cancelledOn?: string | null,
  clientOn?: string | null,
  createdAt?: string | null,
  currentModelId?: string | null,
  currentPlanId?: string | null,
  customerId?: string | null,
  deletedOn?: string | null,
  deletedReason?: string | null,
  email: string,
  emailVerified?: boolean | null,
  endDate?: string | null,
  firstName: string,
  id?: string | null,
  lastAccess?: string | null,
  lastName: string,
  mfaPreference?: string | null,
  migrateStatus?: string | null,
  migratedOn?: string | null,
  phone?: string | null,
  phoneVerified?: boolean | null,
  primaryModelId?: string | null,
  referrer?: string | null,
  referrerDetails?: string | null,
  role: UserRole,
  sessionCount?: number | null,
  startDate?: string | null,
  subscribedOn?: string | null,
  trialEndDate?: string | null,
  updatedAt?: string | null,
  userStatus: UserStatus,
  userType: UserType,
};

export type ModelUserInviteConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelUserInviteConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  invitedOn?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  not?: ModelUserInviteConditionInput | null,
  or?: Array< ModelUserInviteConditionInput | null > | null,
  role?: ModelUserRoleInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateUserInviteInput = {
  accountId: string,
  createdAt?: string | null,
  email: string,
  firstName: string,
  id?: string | null,
  invitedOn: string,
  lastName: string,
  role: UserRole,
  updatedAt?: string | null,
  userId: string,
};

export type ModelUserSettingConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelUserSettingConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  description?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelUserSettingConditionInput | null,
  or?: Array< ModelUserSettingConditionInput | null > | null,
  ownerId?: ModelIDInput | null,
  settingType?: ModelStringInput | null,
  settings?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateUserSettingInput = {
  accountId: string,
  createdAt?: string | null,
  description?: string | null,
  id?: string | null,
  name: string,
  ownerId: string,
  settingType?: string | null,
  settings?: string | null,
  updatedAt?: string | null,
  userId: string,
};

export type DeleteAccountInput = {
  id: string,
};

export type DeleteAssetInput = {
  id: string,
};

export type DeleteAssetCategoryInput = {
  id: string,
};

export type DeleteAssetConversionInput = {
  id: string,
};

export type DeleteAssetTypeInput = {
  id: string,
};

export type DeleteDeductionInput = {
  id: string,
};

export type DeleteExpenseInput = {
  id: string,
};

export type DeleteExpenseCategoryInput = {
  id: string,
};

export type DeleteIncomeInput = {
  id: string,
};

export type DeleteIncomeTypeInput = {
  id: string,
};

export type DeleteLiabilityInput = {
  id: string,
};

export type DeleteMilestoneInput = {
  id: string,
};

export type DeleteModelInput = {
  id: string,
};

export type DeletePersonInput = {
  id: string,
};

export type DeletePlanInput = {
  id: string,
};

export type DeletePlanChangeInput = {
  id: string,
};

export type DeleteReviewInput = {
  id: string,
};

export type DeleteSessionInput = {
  id: string,
};

export type DeleteSnapshotInput = {
  id: string,
};

export type DeleteTaxInput = {
  id: string,
};

export type DeleteTaxValueInput = {
  id: string,
};

export type DeleteUserInput = {
  id: string,
};

export type DeleteUserInviteInput = {
  id: string,
};

export type DeleteUserSettingInput = {
  id: string,
};

export type UpdateAccountInput = {
  address?: string | null,
  city?: string | null,
  createdAt?: string | null,
  id: string,
  name?: string | null,
  ownerId?: string | null,
  postalCode?: string | null,
  state?: string | null,
  updatedAt?: string | null,
};

export type UpdateAssetInput = {
  accountId?: string | null,
  archived?: boolean | null,
  assetCategory?: number | null,
  assetIncome?: AssetIncomeInput | null,
  assetIncomeDate?: string | null,
  assetType?: number | null,
  balance?: number | null,
  balanceDate?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id: string,
  inheritedYear?: number | null,
  managed?: boolean | null,
  modelId?: string | null,
  netWorthExcluded?: boolean | null,
  notes?: string | null,
  originalOwnerBirthYear?: number | null,
  ownerId?: string | null,
  priorEoYBalance?: number | null,
  rateLock?: boolean | null,
  returnRate?: number | null,
  risk?: number | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
  withdrawalOrder?: number | null,
  withdrawalsYTD?: number | null,
};

export type UpdateAssetCategoryInput = {
  createdAt?: string | null,
  description?: string | null,
  id: string,
  sortOrder?: number | null,
  updatedAt?: string | null,
};

export type UpdateAssetConversionInput = {
  accountId?: string | null,
  amount?: number | null,
  archived?: boolean | null,
  completedAt?: string | null,
  conversionType?: string | null,
  createdAt?: string | null,
  description?: string | null,
  dstAssetId?: string | null,
  id: string,
  incomeType?: number | null,
  modelId?: string | null,
  nonTaxableAmount?: number | null,
  percent?: number | null,
  sortOrder?: number | null,
  srcAssetId?: string | null,
  taxableAmount?: number | null,
  updatedAt?: string | null,
  userId?: string | null,
  year?: number | null,
};

export type UpdateAssetTypeInput = {
  createdAt?: string | null,
  description?: string | null,
  id: string,
  updatedAt?: string | null,
};

export type UpdateDeductionInput = {
  accountId?: string | null,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  deductionType?: number | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id: string,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  modelId?: string | null,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateExpenseInput = {
  accountId?: string | null,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  discretionary?: boolean | null,
  end?: string | null,
  endDate?: string | null,
  expenseCategory?: number | null,
  id: string,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  liabilityId?: string | null,
  modelId?: string | null,
  ownerId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateExpenseCategoryInput = {
  createdAt?: string | null,
  description?: string | null,
  id: string,
  sortOrder?: number | null,
  updatedAt?: string | null,
};

export type UpdateIncomeInput = {
  accountId?: string | null,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  assetId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  excludeFromNIIT?: boolean | null,
  grossAmount?: number | null,
  id: string,
  imputed?: boolean | null,
  incomeType?: number | null,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  modelId?: string | null,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  survivorPercent?: number | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateIncomeTypeInput = {
  createdAt?: string | null,
  description?: string | null,
  id: string,
  updatedAt?: string | null,
};

export type UpdateLiabilityInput = {
  accountId?: string | null,
  archived?: boolean | null,
  balance?: number | null,
  balanceDate?: string | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id: string,
  interestRate?: number | null,
  modelId?: string | null,
  ownerId?: string | null,
  payoffDate?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateMilestoneInput = {
  accountId?: string | null,
  age?: number | null,
  archived?: boolean | null,
  createdAt?: string | null,
  date?: string | null,
  description?: string | null,
  id: string,
  label?: string | null,
  modelId?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateModelInput = {
  accountId?: string | null,
  advisorCreated?: boolean | null,
  archived?: boolean | null,
  clientAccess?: ClientAccess | null,
  createdAt?: string | null,
  description?: string | null,
  id: string,
  name?: string | null,
  ownerId?: string | null,
  settings?: string | null,
  startedAt?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  userId?: string | null,
};

export type UpdatePersonInput = {
  accountId?: string | null,
  birthDate?: string | null,
  createdAt?: string | null,
  gender?: Gender | null,
  hereditaryAdjust?: number | null,
  id: string,
  lifeExpectancy?: number | null,
  maritalStatus?: MaritalStatus | null,
  modelId?: string | null,
  nickname?: string | null,
  retireDate?: string | null,
  state?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdatePlanInput = {
  accountId?: string | null,
  archived?: boolean | null,
  createdAt?: string | null,
  default?: boolean | null,
  description?: string | null,
  enabled?: boolean | null,
  id: string,
  modelId?: string | null,
  name?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdatePlanChangeInput = {
  accountId?: string | null,
  changeType?: string | null,
  createdAt?: string | null,
  description?: string | null,
  details?: string | null,
  enabled?: boolean | null,
  id: string,
  modelId?: string | null,
  name?: string | null,
  planId?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateReviewInput = {
  accountId?: string | null,
  archived?: boolean | null,
  baseSnapId?: string | null,
  checklist?: string | null,
  createdAt?: string | null,
  id: string,
  managed?: boolean | null,
  modelId?: string | null,
  ownerId?: string | null,
  reviewDate?: string | null,
  snapshotId?: string | null,
  status?: string | null,
  submittedOn?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateSessionInput = {
  accountId?: string | null,
  createdAt?: string | null,
  duration?: number | null,
  id: string,
  ownerId?: string | null,
  sessionDate?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateSnapshotInput = {
  accountId?: string | null,
  archived?: boolean | null,
  createdAt?: string | null,
  date?: string | null,
  description?: string | null,
  details?: string | null,
  id: string,
  modelId?: string | null,
  snapshotType?: SnapshotType | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateTaxInput = {
  accountId?: string | null,
  amount?: number | null,
  amountDate?: string | null,
  annualInf?: number | null,
  archived?: boolean | null,
  createdAt?: string | null,
  description?: string | null,
  end?: string | null,
  endDate?: string | null,
  id: string,
  infAdjust?: boolean | null,
  infLock?: boolean | null,
  modelId?: string | null,
  ownerId?: string | null,
  paycheckId?: string | null,
  schedule?: string | null,
  sortOrder?: number | null,
  start?: string | null,
  startDate?: string | null,
  taxType?: number | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateTaxValueInput = {
  accountId?: string | null,
  createdAt?: string | null,
  id: string,
  key?: string | null,
  modelId?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
  value?: number | null,
  year?: number | null,
};

export type UpdateUserInput = {
  accountId?: string | null,
  advisorAccess?: boolean | null,
  advisorModelId?: string | null,
  advisorPrimaryModelId?: string | null,
  cancelledOn?: string | null,
  clientOn?: string | null,
  createdAt?: string | null,
  currentModelId?: string | null,
  currentPlanId?: string | null,
  customerId?: string | null,
  deletedOn?: string | null,
  deletedReason?: string | null,
  email?: string | null,
  emailVerified?: boolean | null,
  endDate?: string | null,
  firstName?: string | null,
  id: string,
  lastAccess?: string | null,
  lastName?: string | null,
  mfaPreference?: string | null,
  migrateStatus?: string | null,
  migratedOn?: string | null,
  phone?: string | null,
  phoneVerified?: boolean | null,
  primaryModelId?: string | null,
  referrer?: string | null,
  referrerDetails?: string | null,
  role?: UserRole | null,
  sessionCount?: number | null,
  startDate?: string | null,
  subscribedOn?: string | null,
  trialEndDate?: string | null,
  updatedAt?: string | null,
  userStatus?: UserStatus | null,
  userType?: UserType | null,
};

export type UpdateUserInviteInput = {
  accountId?: string | null,
  createdAt?: string | null,
  email?: string | null,
  firstName?: string | null,
  id: string,
  invitedOn?: string | null,
  lastName?: string | null,
  role?: UserRole | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateUserSettingInput = {
  accountId?: string | null,
  createdAt?: string | null,
  description?: string | null,
  id: string,
  name?: string | null,
  ownerId?: string | null,
  settingType?: string | null,
  settings?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type ModelSubscriptionAccountFilterInput = {
  address?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAccountFilterInput | null > | null,
  city?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAccountFilterInput | null > | null,
  ownerId?: ModelStringInput | null,
  postalCode?: ModelSubscriptionStringInput | null,
  state?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionStringInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionAssetFilterInput = {
  and?: Array< ModelSubscriptionAssetFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  assetCategory?: ModelSubscriptionIntInput | null,
  assetIncomeDate?: ModelSubscriptionStringInput | null,
  assetType?: ModelSubscriptionIntInput | null,
  balance?: ModelSubscriptionIntInput | null,
  balanceDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  end?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  inheritedYear?: ModelSubscriptionIntInput | null,
  managed?: ModelSubscriptionBooleanInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  netWorthExcluded?: ModelSubscriptionBooleanInput | null,
  notes?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAssetFilterInput | null > | null,
  originalOwnerBirthYear?: ModelSubscriptionIntInput | null,
  ownerId?: ModelSubscriptionIDInput | null,
  priorEoYBalance?: ModelSubscriptionIntInput | null,
  rateLock?: ModelSubscriptionBooleanInput | null,
  returnRate?: ModelSubscriptionFloatInput | null,
  risk?: ModelSubscriptionIntInput | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  start?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
  withdrawalOrder?: ModelSubscriptionIntInput | null,
  withdrawalsYTD?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionBooleanInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type ModelSubscriptionIntInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  in?: Array< number | null > | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionIDInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionFloatInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  in?: Array< number | null > | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionAssetCategoryFilterInput = {
  and?: Array< ModelSubscriptionAssetCategoryFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionAssetCategoryFilterInput | null > | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionAssetConversionFilterInput = {
  amount?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionAssetConversionFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  completedAt?: ModelSubscriptionStringInput | null,
  conversionType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  dstAssetId?: ModelSubscriptionIDInput | null,
  id?: ModelSubscriptionIDInput | null,
  incomeType?: ModelSubscriptionIntInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  nonTaxableAmount?: ModelSubscriptionIntInput | null,
  or?: Array< ModelSubscriptionAssetConversionFilterInput | null > | null,
  percent?: ModelSubscriptionFloatInput | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  srcAssetId?: ModelSubscriptionIDInput | null,
  taxableAmount?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
  year?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionAssetTypeFilterInput = {
  and?: Array< ModelSubscriptionAssetTypeFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionAssetTypeFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionDeductionFilterInput = {
  amount?: ModelSubscriptionIntInput | null,
  amountDate?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDeductionFilterInput | null > | null,
  annualInf?: ModelSubscriptionFloatInput | null,
  archived?: ModelSubscriptionBooleanInput | null,
  assetId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deductionType?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  end?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  infAdjust?: ModelSubscriptionBooleanInput | null,
  infLock?: ModelSubscriptionBooleanInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionDeductionFilterInput | null > | null,
  ownerId?: ModelSubscriptionIDInput | null,
  paycheckId?: ModelSubscriptionIDInput | null,
  schedule?: ModelSubscriptionStringInput | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  start?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionExpenseFilterInput = {
  amount?: ModelSubscriptionIntInput | null,
  amountDate?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionExpenseFilterInput | null > | null,
  annualInf?: ModelSubscriptionFloatInput | null,
  archived?: ModelSubscriptionBooleanInput | null,
  assetId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  discretionary?: ModelSubscriptionBooleanInput | null,
  end?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  expenseCategory?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  infAdjust?: ModelSubscriptionBooleanInput | null,
  infLock?: ModelSubscriptionBooleanInput | null,
  liabilityId?: ModelSubscriptionIDInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionExpenseFilterInput | null > | null,
  ownerId?: ModelSubscriptionIDInput | null,
  schedule?: ModelSubscriptionStringInput | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  start?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionExpenseCategoryFilterInput = {
  and?: Array< ModelSubscriptionExpenseCategoryFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionExpenseCategoryFilterInput | null > | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionIncomeFilterInput = {
  amount?: ModelSubscriptionIntInput | null,
  amountDate?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionIncomeFilterInput | null > | null,
  annualInf?: ModelSubscriptionFloatInput | null,
  archived?: ModelSubscriptionBooleanInput | null,
  assetId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  end?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  excludeFromNIIT?: ModelSubscriptionBooleanInput | null,
  grossAmount?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  imputed?: ModelSubscriptionBooleanInput | null,
  incomeType?: ModelSubscriptionIntInput | null,
  infAdjust?: ModelSubscriptionBooleanInput | null,
  infLock?: ModelSubscriptionBooleanInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionIncomeFilterInput | null > | null,
  ownerId?: ModelSubscriptionIDInput | null,
  paycheckId?: ModelSubscriptionIDInput | null,
  schedule?: ModelSubscriptionStringInput | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  start?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  survivorPercent?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionIncomeTypeFilterInput = {
  and?: Array< ModelSubscriptionIncomeTypeFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionIncomeTypeFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionLiabilityFilterInput = {
  and?: Array< ModelSubscriptionLiabilityFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  balance?: ModelSubscriptionIntInput | null,
  balanceDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  end?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  interestRate?: ModelSubscriptionFloatInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionLiabilityFilterInput | null > | null,
  ownerId?: ModelSubscriptionIDInput | null,
  payoffDate?: ModelSubscriptionStringInput | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  start?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionMilestoneFilterInput = {
  age?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionMilestoneFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  date?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  label?: ModelSubscriptionStringInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionMilestoneFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionModelFilterInput = {
  advisorCreated?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionModelFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  clientAccess?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionModelFilterInput | null > | null,
  ownerId?: ModelStringInput | null,
  settings?: ModelSubscriptionStringInput | null,
  startedAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  updatedBy?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionPersonFilterInput = {
  and?: Array< ModelSubscriptionPersonFilterInput | null > | null,
  birthDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  gender?: ModelSubscriptionStringInput | null,
  hereditaryAdjust?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  lifeExpectancy?: ModelSubscriptionIntInput | null,
  maritalStatus?: ModelSubscriptionStringInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  nickname?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionPersonFilterInput | null > | null,
  retireDate?: ModelSubscriptionStringInput | null,
  state?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionPlanFilterInput = {
  and?: Array< ModelSubscriptionPlanFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  default?: ModelSubscriptionBooleanInput | null,
  description?: ModelSubscriptionStringInput | null,
  enabled?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionPlanFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionPlanChangeFilterInput = {
  and?: Array< ModelSubscriptionPlanChangeFilterInput | null > | null,
  changeType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  details?: ModelSubscriptionStringInput | null,
  enabled?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionPlanChangeFilterInput | null > | null,
  planId?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionReviewFilterInput = {
  and?: Array< ModelSubscriptionReviewFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  baseSnapId?: ModelSubscriptionIDInput | null,
  checklist?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  managed?: ModelSubscriptionBooleanInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionReviewFilterInput | null > | null,
  ownerId?: ModelStringInput | null,
  reviewDate?: ModelSubscriptionStringInput | null,
  snapshotId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  submittedOn?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionSessionFilterInput = {
  accountId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionSessionFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  duration?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionSessionFilterInput | null > | null,
  ownerId?: ModelStringInput | null,
  sessionDate?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionSnapshotFilterInput = {
  and?: Array< ModelSubscriptionSnapshotFilterInput | null > | null,
  archived?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  date?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  details?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionSnapshotFilterInput | null > | null,
  snapshotType?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionTaxFilterInput = {
  amount?: ModelSubscriptionIntInput | null,
  amountDate?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTaxFilterInput | null > | null,
  annualInf?: ModelSubscriptionFloatInput | null,
  archived?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  end?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  infAdjust?: ModelSubscriptionBooleanInput | null,
  infLock?: ModelSubscriptionBooleanInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionTaxFilterInput | null > | null,
  ownerId?: ModelSubscriptionIDInput | null,
  paycheckId?: ModelSubscriptionIDInput | null,
  schedule?: ModelSubscriptionStringInput | null,
  sortOrder?: ModelSubscriptionFloatInput | null,
  start?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  taxType?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionTaxValueFilterInput = {
  and?: Array< ModelSubscriptionTaxValueFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  key?: ModelSubscriptionStringInput | null,
  modelId?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionTaxValueFilterInput | null > | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
  value?: ModelSubscriptionFloatInput | null,
  year?: ModelSubscriptionIntInput | null,
};

export type ModelSubscriptionUserFilterInput = {
  advisorAccess?: ModelSubscriptionBooleanInput | null,
  advisorModelId?: ModelSubscriptionIDInput | null,
  advisorPrimaryModelId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  cancelledOn?: ModelSubscriptionStringInput | null,
  clientOn?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  currentModelId?: ModelSubscriptionIDInput | null,
  currentPlanId?: ModelSubscriptionIDInput | null,
  customerId?: ModelSubscriptionStringInput | null,
  deletedOn?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  emailVerified?: ModelSubscriptionBooleanInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  id?: ModelStringInput | null,
  lastAccess?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  mfaPreference?: ModelSubscriptionStringInput | null,
  migrateStatus?: ModelSubscriptionStringInput | null,
  migratedOn?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
  phone?: ModelSubscriptionStringInput | null,
  phoneVerified?: ModelSubscriptionBooleanInput | null,
  primaryModelId?: ModelSubscriptionIDInput | null,
  referrer?: ModelSubscriptionStringInput | null,
  referrerDetails?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  sessionCount?: ModelSubscriptionIntInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  subscribedOn?: ModelSubscriptionStringInput | null,
  trialEndDate?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userStatus?: ModelSubscriptionStringInput | null,
  userType?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionUserInviteFilterInput = {
  accountId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionUserInviteFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  invitedOn?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionUserInviteFilterInput | null > | null,
  role?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelSubscriptionUserSettingFilterInput = {
  and?: Array< ModelSubscriptionUserSettingFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionUserSettingFilterInput | null > | null,
  ownerId?: ModelStringInput | null,
  settingType?: ModelSubscriptionStringInput | null,
  settings?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
};

export type GetAccountQueryVariables = {
  id: string,
};

export type GetAccountQuery = {
  getAccount?:  {
    __typename: "Account",
    address?: string | null,
    city?: string | null,
    createdAt?: string | null,
    id: string,
    name: string,
    ownerId?: string | null,
    postalCode?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type GetAssetQueryVariables = {
  id: string,
};

export type GetAssetQuery = {
  getAsset?:  {
    __typename: "Asset",
    accountId: string,
    archived?: boolean | null,
    assetCategory?: number | null,
    assetIncome?:  {
      __typename: "AssetIncome",
      basis?: number | null,
      rateTotal?: number | null,
      units?: number | null,
    } | null,
    assetIncomeDate?: string | null,
    assetType?: number | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    inheritedYear?: number | null,
    managed?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    netWorthExcluded?: boolean | null,
    notes?: string | null,
    originalOwnerBirthYear?: number | null,
    ownerId?: string | null,
    priorEoYBalance?: number | null,
    rateLock?: boolean | null,
    returnRate?: number | null,
    risk?: number | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
    withdrawalOrder?: number | null,
    withdrawalsYTD?: number | null,
  } | null,
};

export type GetAssetCategoryQueryVariables = {
  id: string,
};

export type GetAssetCategoryQuery = {
  getAssetCategory?:  {
    __typename: "AssetCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type GetAssetConversionQueryVariables = {
  id: string,
};

export type GetAssetConversionQuery = {
  getAssetConversion?:  {
    __typename: "AssetConversion",
    accountId: string,
    amount?: number | null,
    archived?: boolean | null,
    completedAt?: string | null,
    conversionType?: string | null,
    createdAt?: string | null,
    description?: string | null,
    dstAssetId: string,
    id: string,
    incomeType?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nonTaxableAmount?: number | null,
    percent?: number | null,
    sortOrder?: number | null,
    srcAssetId: string,
    taxableAmount?: number | null,
    updatedAt?: string | null,
    userId: string,
    year?: number | null,
  } | null,
};

export type GetAssetTypeQueryVariables = {
  id: string,
};

export type GetAssetTypeQuery = {
  getAssetType?:  {
    __typename: "AssetType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type GetDeductionQueryVariables = {
  id: string,
};

export type GetDeductionQuery = {
  getDeduction?:  {
    __typename: "Deduction",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    deductionType?: number | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetExpenseQueryVariables = {
  id: string,
};

export type GetExpenseQuery = {
  getExpense?:  {
    __typename: "Expense",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    discretionary?: boolean | null,
    end?: string | null,
    endDate?: string | null,
    expenseCategory?: number | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    liabilityId?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetExpenseCategoryQueryVariables = {
  id: string,
};

export type GetExpenseCategoryQuery = {
  getExpenseCategory?:  {
    __typename: "ExpenseCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type GetIncomeQueryVariables = {
  id: string,
};

export type GetIncomeQuery = {
  getIncome?:  {
    __typename: "Income",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    excludeFromNIIT?: boolean | null,
    grossAmount?: number | null,
    id: string,
    imputed?: boolean | null,
    incomeType?: number | null,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    survivorPercent?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetIncomeTypeQueryVariables = {
  id: string,
};

export type GetIncomeTypeQuery = {
  getIncomeType?:  {
    __typename: "IncomeType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type GetLiabilityQueryVariables = {
  id: string,
};

export type GetLiabilityQuery = {
  getLiability?:  {
    __typename: "Liability",
    accountId: string,
    archived?: boolean | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    interestRate?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    payoffDate?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetMilestoneQueryVariables = {
  id: string,
};

export type GetMilestoneQuery = {
  getMilestone?:  {
    __typename: "Milestone",
    accountId: string,
    age?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    date?: string | null,
    description?: string | null,
    id: string,
    label?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetModelQueryVariables = {
  id: string,
};

export type GetModelQuery = {
  getModel?:  {
    __typename: "Model",
    accountId: string,
    advisorCreated?: boolean | null,
    archived?: boolean | null,
    assetConversions?:  {
      __typename: "ModelAssetConversionConnection",
      nextToken?: string | null,
    } | null,
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    clientAccess?: ClientAccess | null,
    createdAt?: string | null,
    deductions?:  {
      __typename: "ModelDeductionConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    expenses?:  {
      __typename: "ModelExpenseConnection",
      nextToken?: string | null,
    } | null,
    id: string,
    incomes?:  {
      __typename: "ModelIncomeConnection",
      nextToken?: string | null,
    } | null,
    liabilities?:  {
      __typename: "ModelLiabilityConnection",
      nextToken?: string | null,
    } | null,
    milestones?:  {
      __typename: "ModelMilestoneConnection",
      nextToken?: string | null,
    } | null,
    name: string,
    ownerId: string,
    persons?:  {
      __typename: "ModelPersonConnection",
      nextToken?: string | null,
    } | null,
    plans?:  {
      __typename: "ModelPlanConnection",
      nextToken?: string | null,
    } | null,
    settings?: string | null,
    snapshots?:  {
      __typename: "ModelSnapshotConnection",
      nextToken?: string | null,
    } | null,
    startedAt?: string | null,
    taxValues?:  {
      __typename: "ModelTaxValueConnection",
      nextToken?: string | null,
    } | null,
    taxes?:  {
      __typename: "ModelTaxConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type GetPersonQueryVariables = {
  id: string,
};

export type GetPersonQuery = {
  getPerson?:  {
    __typename: "Person",
    accountId: string,
    birthDate?: string | null,
    createdAt?: string | null,
    gender?: Gender | null,
    hereditaryAdjust?: number | null,
    id: string,
    lifeExpectancy?: number | null,
    maritalStatus?: MaritalStatus | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nickname?: string | null,
    retireDate?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetPlanQueryVariables = {
  id: string,
};

export type GetPlanQuery = {
  getPlan?:  {
    __typename: "Plan",
    accountId: string,
    archived?: boolean | null,
    changes?:  {
      __typename: "ModelPlanChangeConnection",
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    default?: boolean | null,
    description?: string | null,
    enabled?: boolean | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    name?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetPlanChangeQueryVariables = {
  id: string,
};

export type GetPlanChangeQuery = {
  getPlanChange?:  {
    __typename: "PlanChange",
    accountId: string,
    changeType: string,
    createdAt?: string | null,
    description?: string | null,
    details?: string | null,
    enabled?: boolean | null,
    id: string,
    modelId: string,
    name: string,
    plan?:  {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null,
    planId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetPublicUserInviteQueryVariables = {
  id: string,
};

export type GetPublicUserInviteQuery = {
  getPublicUserInvite?: string | null,
};

export type GetReviewQueryVariables = {
  id: string,
};

export type GetReviewQuery = {
  getReview?:  {
    __typename: "Review",
    accountId: string,
    archived?: boolean | null,
    baseSnapId?: string | null,
    checklist?: string | null,
    createdAt?: string | null,
    id: string,
    managed?: boolean | null,
    modelId: string,
    ownerId: string,
    reviewDate?: string | null,
    snapshotId?: string | null,
    status?: string | null,
    submittedOn?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type GetSessionQueryVariables = {
  id: string,
};

export type GetSessionQuery = {
  getSession?:  {
    __typename: "Session",
    accountId: string,
    createdAt?: string | null,
    duration?: number | null,
    id: string,
    ownerId: string,
    sessionDate?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type GetSnapshotQueryVariables = {
  id: string,
};

export type GetSnapshotQuery = {
  getSnapshot?:  {
    __typename: "Snapshot",
    accountId: string,
    archived?: boolean | null,
    createdAt?: string | null,
    date: string,
    description?: string | null,
    details?: string | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    snapshotType?: SnapshotType | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetTaxQueryVariables = {
  id: string,
};

export type GetTaxQuery = {
  getTax?:  {
    __typename: "Tax",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    taxType?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetTaxValueQueryVariables = {
  id: string,
};

export type GetTaxValueQuery = {
  getTaxValue?:  {
    __typename: "TaxValue",
    accountId: string,
    createdAt?: string | null,
    id: string,
    key: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
    value: number,
    year: number,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    account?:  {
      __typename: "Account",
      address?: string | null,
      city?: string | null,
      createdAt?: string | null,
      id: string,
      name: string,
      ownerId?: string | null,
      postalCode?: string | null,
      state?: string | null,
      updatedAt?: string | null,
    } | null,
    accountId: string,
    advisorAccess?: boolean | null,
    advisorModelId?: string | null,
    advisorPrimaryModelId?: string | null,
    cancelledOn?: string | null,
    clientOn?: string | null,
    createdAt?: string | null,
    currentModelId?: string | null,
    currentPlanId?: string | null,
    customerId?: string | null,
    deletedOn?: string | null,
    deletedReason?: string | null,
    email: string,
    emailVerified?: boolean | null,
    endDate?: string | null,
    firstName: string,
    id: string,
    lastAccess?: string | null,
    lastName: string,
    mfaPreference?: string | null,
    migrateStatus?: string | null,
    migratedOn?: string | null,
    models?:  {
      __typename: "ModelModelConnection",
      nextToken?: string | null,
    } | null,
    phone?: string | null,
    phoneVerified?: boolean | null,
    primaryModelId?: string | null,
    referrer?: string | null,
    referrerDetails?: string | null,
    reviews?:  {
      __typename: "ModelReviewConnection",
      nextToken?: string | null,
    } | null,
    role: UserRole,
    sessionCount?: number | null,
    sessions?:  {
      __typename: "ModelSessionConnection",
      nextToken?: string | null,
    } | null,
    settings?:  {
      __typename: "ModelUserSettingConnection",
      nextToken?: string | null,
    } | null,
    startDate?: string | null,
    subscribedOn?: string | null,
    trialEndDate?: string | null,
    updatedAt?: string | null,
    userStatus: UserStatus,
    userType: UserType,
  } | null,
};

export type GetUserInviteQueryVariables = {
  id: string,
};

export type GetUserInviteQuery = {
  getUserInvite?:  {
    __typename: "UserInvite",
    accountId: string,
    createdAt?: string | null,
    email: string,
    firstName: string,
    id: string,
    invitedOn: string,
    lastName: string,
    role: UserRole,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type GetUserSettingQueryVariables = {
  id: string,
};

export type GetUserSettingQuery = {
  getUserSetting?:  {
    __typename: "UserSetting",
    accountId: string,
    createdAt?: string | null,
    description?: string | null,
    id: string,
    name: string,
    ownerId: string,
    settingType?: string | null,
    settings?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type ListAccountsQueryVariables = {
  filter?: ModelAccountFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAccountsQuery = {
  listAccounts?:  {
    __typename: "ModelAccountConnection",
    items:  Array< {
      __typename: "Account",
      address?: string | null,
      city?: string | null,
      createdAt?: string | null,
      id: string,
      name: string,
      ownerId?: string | null,
      postalCode?: string | null,
      state?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetCategoriesQueryVariables = {
  filter?: ModelAssetCategoryFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssetCategoriesQuery = {
  listAssetCategories?:  {
    __typename: "ModelAssetCategoryConnection",
    items:  Array< {
      __typename: "AssetCategory",
      createdAt?: string | null,
      description?: string | null,
      id: string,
      sortOrder?: number | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetConversionsQueryVariables = {
  filter?: ModelAssetConversionFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssetConversionsQuery = {
  listAssetConversions?:  {
    __typename: "ModelAssetConversionConnection",
    items:  Array< {
      __typename: "AssetConversion",
      accountId: string,
      amount?: number | null,
      archived?: boolean | null,
      completedAt?: string | null,
      conversionType?: string | null,
      createdAt?: string | null,
      description?: string | null,
      dstAssetId: string,
      id: string,
      incomeType?: number | null,
      modelId: string,
      nonTaxableAmount?: number | null,
      percent?: number | null,
      sortOrder?: number | null,
      srcAssetId: string,
      taxableAmount?: number | null,
      updatedAt?: string | null,
      userId: string,
      year?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetConversionsByModelQueryVariables = {
  filter?: ModelAssetConversionFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssetConversionsByModelQuery = {
  listAssetConversionsByModel?:  {
    __typename: "ModelAssetConversionConnection",
    items:  Array< {
      __typename: "AssetConversion",
      accountId: string,
      amount?: number | null,
      archived?: boolean | null,
      completedAt?: string | null,
      conversionType?: string | null,
      createdAt?: string | null,
      description?: string | null,
      dstAssetId: string,
      id: string,
      incomeType?: number | null,
      modelId: string,
      nonTaxableAmount?: number | null,
      percent?: number | null,
      sortOrder?: number | null,
      srcAssetId: string,
      taxableAmount?: number | null,
      updatedAt?: string | null,
      userId: string,
      year?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetTypesQueryVariables = {
  filter?: ModelAssetTypeFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssetTypesQuery = {
  listAssetTypes?:  {
    __typename: "ModelAssetTypeConnection",
    items:  Array< {
      __typename: "AssetType",
      createdAt?: string | null,
      description?: string | null,
      id: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetsQueryVariables = {
  filter?: ModelAssetFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssetsQuery = {
  listAssets?:  {
    __typename: "ModelAssetConnection",
    items:  Array< {
      __typename: "Asset",
      accountId: string,
      archived?: boolean | null,
      assetCategory?: number | null,
      assetIncomeDate?: string | null,
      assetType?: number | null,
      balance?: number | null,
      balanceDate?: string | null,
      createdAt?: string | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      id: string,
      inheritedYear?: number | null,
      managed?: boolean | null,
      modelId: string,
      netWorthExcluded?: boolean | null,
      notes?: string | null,
      originalOwnerBirthYear?: number | null,
      ownerId?: string | null,
      priorEoYBalance?: number | null,
      rateLock?: boolean | null,
      returnRate?: number | null,
      risk?: number | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      updatedAt?: string | null,
      userId: string,
      withdrawalOrder?: number | null,
      withdrawalsYTD?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssetsByModelQueryVariables = {
  filter?: ModelAssetFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssetsByModelQuery = {
  listAssetsByModel?:  {
    __typename: "ModelAssetConnection",
    items:  Array< {
      __typename: "Asset",
      accountId: string,
      archived?: boolean | null,
      assetCategory?: number | null,
      assetIncomeDate?: string | null,
      assetType?: number | null,
      balance?: number | null,
      balanceDate?: string | null,
      createdAt?: string | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      id: string,
      inheritedYear?: number | null,
      managed?: boolean | null,
      modelId: string,
      netWorthExcluded?: boolean | null,
      notes?: string | null,
      originalOwnerBirthYear?: number | null,
      ownerId?: string | null,
      priorEoYBalance?: number | null,
      rateLock?: boolean | null,
      returnRate?: number | null,
      risk?: number | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      updatedAt?: string | null,
      userId: string,
      withdrawalOrder?: number | null,
      withdrawalsYTD?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChangesByPlanQueryVariables = {
  filter?: ModelPlanChangeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  planId: string,
  sortDirection?: ModelSortDirection | null,
};

export type ListChangesByPlanQuery = {
  listChangesByPlan?:  {
    __typename: "ModelPlanChangeConnection",
    items:  Array< {
      __typename: "PlanChange",
      accountId: string,
      changeType: string,
      createdAt?: string | null,
      description?: string | null,
      details?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name: string,
      planId: string,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDeductionsQueryVariables = {
  filter?: ModelDeductionFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDeductionsQuery = {
  listDeductions?:  {
    __typename: "ModelDeductionConnection",
    items:  Array< {
      __typename: "Deduction",
      accountId: string,
      amount?: number | null,
      amountDate?: string | null,
      annualInf?: number | null,
      archived?: boolean | null,
      assetId?: string | null,
      createdAt?: string | null,
      deductionType?: number | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      id: string,
      infAdjust?: boolean | null,
      infLock?: boolean | null,
      modelId: string,
      ownerId?: string | null,
      paycheckId?: string | null,
      schedule?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDeductionsByModelQueryVariables = {
  filter?: ModelDeductionFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDeductionsByModelQuery = {
  listDeductionsByModel?:  {
    __typename: "ModelDeductionConnection",
    items:  Array< {
      __typename: "Deduction",
      accountId: string,
      amount?: number | null,
      amountDate?: string | null,
      annualInf?: number | null,
      archived?: boolean | null,
      assetId?: string | null,
      createdAt?: string | null,
      deductionType?: number | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      id: string,
      infAdjust?: boolean | null,
      infLock?: boolean | null,
      modelId: string,
      ownerId?: string | null,
      paycheckId?: string | null,
      schedule?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListExpenseCategoriesQueryVariables = {
  filter?: ModelExpenseCategoryFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListExpenseCategoriesQuery = {
  listExpenseCategories?:  {
    __typename: "ModelExpenseCategoryConnection",
    items:  Array< {
      __typename: "ExpenseCategory",
      createdAt?: string | null,
      description?: string | null,
      id: string,
      sortOrder?: number | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListExpensesQueryVariables = {
  filter?: ModelExpenseFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListExpensesQuery = {
  listExpenses?:  {
    __typename: "ModelExpenseConnection",
    items:  Array< {
      __typename: "Expense",
      accountId: string,
      amount?: number | null,
      amountDate?: string | null,
      annualInf?: number | null,
      archived?: boolean | null,
      assetId?: string | null,
      createdAt?: string | null,
      description?: string | null,
      discretionary?: boolean | null,
      end?: string | null,
      endDate?: string | null,
      expenseCategory?: number | null,
      id: string,
      infAdjust?: boolean | null,
      infLock?: boolean | null,
      liabilityId?: string | null,
      modelId: string,
      ownerId?: string | null,
      schedule?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListExpensesByModelQueryVariables = {
  filter?: ModelExpenseFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListExpensesByModelQuery = {
  listExpensesByModel?:  {
    __typename: "ModelExpenseConnection",
    items:  Array< {
      __typename: "Expense",
      accountId: string,
      amount?: number | null,
      amountDate?: string | null,
      annualInf?: number | null,
      archived?: boolean | null,
      assetId?: string | null,
      createdAt?: string | null,
      description?: string | null,
      discretionary?: boolean | null,
      end?: string | null,
      endDate?: string | null,
      expenseCategory?: number | null,
      id: string,
      infAdjust?: boolean | null,
      infLock?: boolean | null,
      liabilityId?: string | null,
      modelId: string,
      ownerId?: string | null,
      schedule?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListIncomeTypesQueryVariables = {
  filter?: ModelIncomeTypeFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListIncomeTypesQuery = {
  listIncomeTypes?:  {
    __typename: "ModelIncomeTypeConnection",
    items:  Array< {
      __typename: "IncomeType",
      createdAt?: string | null,
      description?: string | null,
      id: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListIncomesQueryVariables = {
  filter?: ModelIncomeFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListIncomesQuery = {
  listIncomes?:  {
    __typename: "ModelIncomeConnection",
    items:  Array< {
      __typename: "Income",
      accountId: string,
      amount?: number | null,
      amountDate?: string | null,
      annualInf?: number | null,
      archived?: boolean | null,
      assetId?: string | null,
      createdAt?: string | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      excludeFromNIIT?: boolean | null,
      grossAmount?: number | null,
      id: string,
      imputed?: boolean | null,
      incomeType?: number | null,
      infAdjust?: boolean | null,
      infLock?: boolean | null,
      modelId: string,
      ownerId?: string | null,
      paycheckId?: string | null,
      schedule?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      survivorPercent?: number | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListIncomesByModelQueryVariables = {
  filter?: ModelIncomeFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListIncomesByModelQuery = {
  listIncomesByModel?:  {
    __typename: "ModelIncomeConnection",
    items:  Array< {
      __typename: "Income",
      accountId: string,
      amount?: number | null,
      amountDate?: string | null,
      annualInf?: number | null,
      archived?: boolean | null,
      assetId?: string | null,
      createdAt?: string | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      excludeFromNIIT?: boolean | null,
      grossAmount?: number | null,
      id: string,
      imputed?: boolean | null,
      incomeType?: number | null,
      infAdjust?: boolean | null,
      infLock?: boolean | null,
      modelId: string,
      ownerId?: string | null,
      paycheckId?: string | null,
      schedule?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      survivorPercent?: number | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLiabilitiesQueryVariables = {
  filter?: ModelLiabilityFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLiabilitiesQuery = {
  listLiabilities?:  {
    __typename: "ModelLiabilityConnection",
    items:  Array< {
      __typename: "Liability",
      accountId: string,
      archived?: boolean | null,
      balance?: number | null,
      balanceDate?: string | null,
      createdAt?: string | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      id: string,
      interestRate?: number | null,
      modelId: string,
      ownerId?: string | null,
      payoffDate?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLiabilitiesByModelQueryVariables = {
  filter?: ModelLiabilityFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLiabilitiesByModelQuery = {
  listLiabilitiesByModel?:  {
    __typename: "ModelLiabilityConnection",
    items:  Array< {
      __typename: "Liability",
      accountId: string,
      archived?: boolean | null,
      balance?: number | null,
      balanceDate?: string | null,
      createdAt?: string | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      id: string,
      interestRate?: number | null,
      modelId: string,
      ownerId?: string | null,
      payoffDate?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMilestonesQueryVariables = {
  filter?: ModelMilestoneFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMilestonesQuery = {
  listMilestones?:  {
    __typename: "ModelMilestoneConnection",
    items:  Array< {
      __typename: "Milestone",
      accountId: string,
      age?: number | null,
      archived?: boolean | null,
      createdAt?: string | null,
      date?: string | null,
      description?: string | null,
      id: string,
      label?: string | null,
      modelId: string,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMilestonesByModelQueryVariables = {
  filter?: ModelMilestoneFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMilestonesByModelQuery = {
  listMilestonesByModel?:  {
    __typename: "ModelMilestoneConnection",
    items:  Array< {
      __typename: "Milestone",
      accountId: string,
      age?: number | null,
      archived?: boolean | null,
      createdAt?: string | null,
      date?: string | null,
      description?: string | null,
      id: string,
      label?: string | null,
      modelId: string,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListModelsQueryVariables = {
  filter?: ModelModelFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListModelsQuery = {
  listModels?:  {
    __typename: "ModelModelConnection",
    items:  Array< {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListModelsByUserQueryVariables = {
  filter?: ModelModelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListModelsByUserQuery = {
  listModelsByUser?:  {
    __typename: "ModelModelConnection",
    items:  Array< {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPeopleQueryVariables = {
  filter?: ModelPersonFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPeopleQuery = {
  listPeople?:  {
    __typename: "ModelPersonConnection",
    items:  Array< {
      __typename: "Person",
      accountId: string,
      birthDate?: string | null,
      createdAt?: string | null,
      gender?: Gender | null,
      hereditaryAdjust?: number | null,
      id: string,
      lifeExpectancy?: number | null,
      maritalStatus?: MaritalStatus | null,
      modelId: string,
      nickname?: string | null,
      retireDate?: string | null,
      state?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPersonsByModelQueryVariables = {
  filter?: ModelPersonFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPersonsByModelQuery = {
  listPersonsByModel?:  {
    __typename: "ModelPersonConnection",
    items:  Array< {
      __typename: "Person",
      accountId: string,
      birthDate?: string | null,
      createdAt?: string | null,
      gender?: Gender | null,
      hereditaryAdjust?: number | null,
      id: string,
      lifeExpectancy?: number | null,
      maritalStatus?: MaritalStatus | null,
      modelId: string,
      nickname?: string | null,
      retireDate?: string | null,
      state?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPlanChangesQueryVariables = {
  filter?: ModelPlanChangeFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPlanChangesQuery = {
  listPlanChanges?:  {
    __typename: "ModelPlanChangeConnection",
    items:  Array< {
      __typename: "PlanChange",
      accountId: string,
      changeType: string,
      createdAt?: string | null,
      description?: string | null,
      details?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name: string,
      planId: string,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPlansQueryVariables = {
  filter?: ModelPlanFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPlansQuery = {
  listPlans?:  {
    __typename: "ModelPlanConnection",
    items:  Array< {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPlansByModelQueryVariables = {
  filter?: ModelPlanFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPlansByModelQuery = {
  listPlansByModel?:  {
    __typename: "ModelPlanConnection",
    items:  Array< {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReviewsQueryVariables = {
  filter?: ModelReviewFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReviewsQuery = {
  listReviews?:  {
    __typename: "ModelReviewConnection",
    items:  Array< {
      __typename: "Review",
      accountId: string,
      archived?: boolean | null,
      baseSnapId?: string | null,
      checklist?: string | null,
      createdAt?: string | null,
      id: string,
      managed?: boolean | null,
      modelId: string,
      ownerId: string,
      reviewDate?: string | null,
      snapshotId?: string | null,
      status?: string | null,
      submittedOn?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReviewsByModelQueryVariables = {
  filter?: ModelReviewFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReviewsByModelQuery = {
  listReviewsByModel?:  {
    __typename: "ModelReviewConnection",
    items:  Array< {
      __typename: "Review",
      accountId: string,
      archived?: boolean | null,
      baseSnapId?: string | null,
      checklist?: string | null,
      createdAt?: string | null,
      id: string,
      managed?: boolean | null,
      modelId: string,
      ownerId: string,
      reviewDate?: string | null,
      snapshotId?: string | null,
      status?: string | null,
      submittedOn?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReviewsByUserQueryVariables = {
  filter?: ModelReviewFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListReviewsByUserQuery = {
  listReviewsByUser?:  {
    __typename: "ModelReviewConnection",
    items:  Array< {
      __typename: "Review",
      accountId: string,
      archived?: boolean | null,
      baseSnapId?: string | null,
      checklist?: string | null,
      createdAt?: string | null,
      id: string,
      managed?: boolean | null,
      modelId: string,
      ownerId: string,
      reviewDate?: string | null,
      snapshotId?: string | null,
      status?: string | null,
      submittedOn?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSessionsQueryVariables = {
  filter?: ModelSessionFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSessionsQuery = {
  listSessions?:  {
    __typename: "ModelSessionConnection",
    items:  Array< {
      __typename: "Session",
      accountId: string,
      createdAt?: string | null,
      duration?: number | null,
      id: string,
      ownerId: string,
      sessionDate?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSessionsByUserQueryVariables = {
  filter?: ModelSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sessionDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListSessionsByUserQuery = {
  listSessionsByUser?:  {
    __typename: "ModelSessionConnection",
    items:  Array< {
      __typename: "Session",
      accountId: string,
      createdAt?: string | null,
      duration?: number | null,
      id: string,
      ownerId: string,
      sessionDate?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSnapshotsQueryVariables = {
  filter?: ModelSnapshotFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSnapshotsQuery = {
  listSnapshots?:  {
    __typename: "ModelSnapshotConnection",
    items:  Array< {
      __typename: "Snapshot",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      date: string,
      description?: string | null,
      details?: string | null,
      id: string,
      modelId: string,
      snapshotType?: SnapshotType | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSnapshotsByModelQueryVariables = {
  date?: ModelStringKeyConditionInput | null,
  filter?: ModelSnapshotFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSnapshotsByModelQuery = {
  listSnapshotsByModel?:  {
    __typename: "ModelSnapshotConnection",
    items:  Array< {
      __typename: "Snapshot",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      date: string,
      description?: string | null,
      details?: string | null,
      id: string,
      modelId: string,
      snapshotType?: SnapshotType | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaxValuesQueryVariables = {
  filter?: ModelTaxValueFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTaxValuesQuery = {
  listTaxValues?:  {
    __typename: "ModelTaxValueConnection",
    items:  Array< {
      __typename: "TaxValue",
      accountId: string,
      createdAt?: string | null,
      id: string,
      key: string,
      modelId: string,
      updatedAt?: string | null,
      userId: string,
      value: number,
      year: number,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaxValuesByModelQueryVariables = {
  filter?: ModelTaxValueFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  year?: ModelIntKeyConditionInput | null,
};

export type ListTaxValuesByModelQuery = {
  listTaxValuesByModel?:  {
    __typename: "ModelTaxValueConnection",
    items:  Array< {
      __typename: "TaxValue",
      accountId: string,
      createdAt?: string | null,
      id: string,
      key: string,
      modelId: string,
      updatedAt?: string | null,
      userId: string,
      value: number,
      year: number,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaxesQueryVariables = {
  filter?: ModelTaxFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTaxesQuery = {
  listTaxes?:  {
    __typename: "ModelTaxConnection",
    items:  Array< {
      __typename: "Tax",
      accountId: string,
      amount?: number | null,
      amountDate?: string | null,
      annualInf?: number | null,
      archived?: boolean | null,
      createdAt?: string | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      id: string,
      infAdjust?: boolean | null,
      infLock?: boolean | null,
      modelId: string,
      ownerId?: string | null,
      paycheckId?: string | null,
      schedule?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      taxType?: number | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaxesByModelQueryVariables = {
  filter?: ModelTaxFilterInput | null,
  limit?: number | null,
  modelId: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTaxesByModelQuery = {
  listTaxesByModel?:  {
    __typename: "ModelTaxConnection",
    items:  Array< {
      __typename: "Tax",
      accountId: string,
      amount?: number | null,
      amountDate?: string | null,
      annualInf?: number | null,
      archived?: boolean | null,
      createdAt?: string | null,
      description?: string | null,
      end?: string | null,
      endDate?: string | null,
      id: string,
      infAdjust?: boolean | null,
      infLock?: boolean | null,
      modelId: string,
      ownerId?: string | null,
      paycheckId?: string | null,
      schedule?: string | null,
      sortOrder?: number | null,
      start?: string | null,
      startDate?: string | null,
      taxType?: number | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserInvitesQueryVariables = {
  filter?: ModelUserInviteFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserInvitesQuery = {
  listUserInvites?:  {
    __typename: "ModelUserInviteConnection",
    items:  Array< {
      __typename: "UserInvite",
      accountId: string,
      createdAt?: string | null,
      email: string,
      firstName: string,
      id: string,
      invitedOn: string,
      lastName: string,
      role: UserRole,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserInvitesByAccountQueryVariables = {
  accountId: string,
  filter?: ModelUserInviteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserInvitesByAccountQuery = {
  listUserInvitesByAccount?:  {
    __typename: "ModelUserInviteConnection",
    items:  Array< {
      __typename: "UserInvite",
      accountId: string,
      createdAt?: string | null,
      email: string,
      firstName: string,
      id: string,
      invitedOn: string,
      lastName: string,
      role: UserRole,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserSettingsQueryVariables = {
  filter?: ModelUserSettingFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserSettingsQuery = {
  listUserSettings?:  {
    __typename: "ModelUserSettingConnection",
    items:  Array< {
      __typename: "UserSetting",
      accountId: string,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settingType?: string | null,
      settings?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserSettingsByUserQueryVariables = {
  filter?: ModelUserSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ListUserSettingsByUserQuery = {
  listUserSettingsByUser?:  {
    __typename: "ModelUserSettingConnection",
    items:  Array< {
      __typename: "UserSetting",
      accountId: string,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settingType?: string | null,
      settings?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUsersByAccountQueryVariables = {
  accountId: string,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersByAccountQuery = {
  listUsersByAccount?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CreateAccountMutationVariables = {
  condition?: ModelAccountConditionInput | null,
  input: CreateAccountInput,
};

export type CreateAccountMutation = {
  createAccount?:  {
    __typename: "Account",
    address?: string | null,
    city?: string | null,
    createdAt?: string | null,
    id: string,
    name: string,
    ownerId?: string | null,
    postalCode?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateAssetMutationVariables = {
  condition?: ModelAssetConditionInput | null,
  input: CreateAssetInput,
};

export type CreateAssetMutation = {
  createAsset?:  {
    __typename: "Asset",
    accountId: string,
    archived?: boolean | null,
    assetCategory?: number | null,
    assetIncome?:  {
      __typename: "AssetIncome",
      basis?: number | null,
      rateTotal?: number | null,
      units?: number | null,
    } | null,
    assetIncomeDate?: string | null,
    assetType?: number | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    inheritedYear?: number | null,
    managed?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    netWorthExcluded?: boolean | null,
    notes?: string | null,
    originalOwnerBirthYear?: number | null,
    ownerId?: string | null,
    priorEoYBalance?: number | null,
    rateLock?: boolean | null,
    returnRate?: number | null,
    risk?: number | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
    withdrawalOrder?: number | null,
    withdrawalsYTD?: number | null,
  } | null,
};

export type CreateAssetCategoryMutationVariables = {
  condition?: ModelAssetCategoryConditionInput | null,
  input: CreateAssetCategoryInput,
};

export type CreateAssetCategoryMutation = {
  createAssetCategory?:  {
    __typename: "AssetCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAssetConversionMutationVariables = {
  condition?: ModelAssetConversionConditionInput | null,
  input: CreateAssetConversionInput,
};

export type CreateAssetConversionMutation = {
  createAssetConversion?:  {
    __typename: "AssetConversion",
    accountId: string,
    amount?: number | null,
    archived?: boolean | null,
    completedAt?: string | null,
    conversionType?: string | null,
    createdAt?: string | null,
    description?: string | null,
    dstAssetId: string,
    id: string,
    incomeType?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nonTaxableAmount?: number | null,
    percent?: number | null,
    sortOrder?: number | null,
    srcAssetId: string,
    taxableAmount?: number | null,
    updatedAt?: string | null,
    userId: string,
    year?: number | null,
  } | null,
};

export type CreateAssetTypeMutationVariables = {
  condition?: ModelAssetTypeConditionInput | null,
  input: CreateAssetTypeInput,
};

export type CreateAssetTypeMutation = {
  createAssetType?:  {
    __typename: "AssetType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type CreateDeductionMutationVariables = {
  condition?: ModelDeductionConditionInput | null,
  input: CreateDeductionInput,
};

export type CreateDeductionMutation = {
  createDeduction?:  {
    __typename: "Deduction",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    deductionType?: number | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateExpenseMutationVariables = {
  condition?: ModelExpenseConditionInput | null,
  input: CreateExpenseInput,
};

export type CreateExpenseMutation = {
  createExpense?:  {
    __typename: "Expense",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    discretionary?: boolean | null,
    end?: string | null,
    endDate?: string | null,
    expenseCategory?: number | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    liabilityId?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateExpenseCategoryMutationVariables = {
  condition?: ModelExpenseCategoryConditionInput | null,
  input: CreateExpenseCategoryInput,
};

export type CreateExpenseCategoryMutation = {
  createExpenseCategory?:  {
    __typename: "ExpenseCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateIncomeMutationVariables = {
  condition?: ModelIncomeConditionInput | null,
  input: CreateIncomeInput,
};

export type CreateIncomeMutation = {
  createIncome?:  {
    __typename: "Income",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    excludeFromNIIT?: boolean | null,
    grossAmount?: number | null,
    id: string,
    imputed?: boolean | null,
    incomeType?: number | null,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    survivorPercent?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateIncomeTypeMutationVariables = {
  condition?: ModelIncomeTypeConditionInput | null,
  input: CreateIncomeTypeInput,
};

export type CreateIncomeTypeMutation = {
  createIncomeType?:  {
    __typename: "IncomeType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type CreateLiabilityMutationVariables = {
  condition?: ModelLiabilityConditionInput | null,
  input: CreateLiabilityInput,
};

export type CreateLiabilityMutation = {
  createLiability?:  {
    __typename: "Liability",
    accountId: string,
    archived?: boolean | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    interestRate?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    payoffDate?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateMilestoneMutationVariables = {
  condition?: ModelMilestoneConditionInput | null,
  input: CreateMilestoneInput,
};

export type CreateMilestoneMutation = {
  createMilestone?:  {
    __typename: "Milestone",
    accountId: string,
    age?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    date?: string | null,
    description?: string | null,
    id: string,
    label?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateModelMutationVariables = {
  condition?: ModelModelConditionInput | null,
  input: CreateModelInput,
};

export type CreateModelMutation = {
  createModel?:  {
    __typename: "Model",
    accountId: string,
    advisorCreated?: boolean | null,
    archived?: boolean | null,
    assetConversions?:  {
      __typename: "ModelAssetConversionConnection",
      nextToken?: string | null,
    } | null,
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    clientAccess?: ClientAccess | null,
    createdAt?: string | null,
    deductions?:  {
      __typename: "ModelDeductionConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    expenses?:  {
      __typename: "ModelExpenseConnection",
      nextToken?: string | null,
    } | null,
    id: string,
    incomes?:  {
      __typename: "ModelIncomeConnection",
      nextToken?: string | null,
    } | null,
    liabilities?:  {
      __typename: "ModelLiabilityConnection",
      nextToken?: string | null,
    } | null,
    milestones?:  {
      __typename: "ModelMilestoneConnection",
      nextToken?: string | null,
    } | null,
    name: string,
    ownerId: string,
    persons?:  {
      __typename: "ModelPersonConnection",
      nextToken?: string | null,
    } | null,
    plans?:  {
      __typename: "ModelPlanConnection",
      nextToken?: string | null,
    } | null,
    settings?: string | null,
    snapshots?:  {
      __typename: "ModelSnapshotConnection",
      nextToken?: string | null,
    } | null,
    startedAt?: string | null,
    taxValues?:  {
      __typename: "ModelTaxValueConnection",
      nextToken?: string | null,
    } | null,
    taxes?:  {
      __typename: "ModelTaxConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type CreatePersonMutationVariables = {
  condition?: ModelPersonConditionInput | null,
  input: CreatePersonInput,
};

export type CreatePersonMutation = {
  createPerson?:  {
    __typename: "Person",
    accountId: string,
    birthDate?: string | null,
    createdAt?: string | null,
    gender?: Gender | null,
    hereditaryAdjust?: number | null,
    id: string,
    lifeExpectancy?: number | null,
    maritalStatus?: MaritalStatus | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nickname?: string | null,
    retireDate?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreatePlanMutationVariables = {
  condition?: ModelPlanConditionInput | null,
  input: CreatePlanInput,
};

export type CreatePlanMutation = {
  createPlan?:  {
    __typename: "Plan",
    accountId: string,
    archived?: boolean | null,
    changes?:  {
      __typename: "ModelPlanChangeConnection",
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    default?: boolean | null,
    description?: string | null,
    enabled?: boolean | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    name?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreatePlanChangeMutationVariables = {
  condition?: ModelPlanChangeConditionInput | null,
  input: CreatePlanChangeInput,
};

export type CreatePlanChangeMutation = {
  createPlanChange?:  {
    __typename: "PlanChange",
    accountId: string,
    changeType: string,
    createdAt?: string | null,
    description?: string | null,
    details?: string | null,
    enabled?: boolean | null,
    id: string,
    modelId: string,
    name: string,
    plan?:  {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null,
    planId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateReviewMutationVariables = {
  condition?: ModelReviewConditionInput | null,
  input: CreateReviewInput,
};

export type CreateReviewMutation = {
  createReview?:  {
    __typename: "Review",
    accountId: string,
    archived?: boolean | null,
    baseSnapId?: string | null,
    checklist?: string | null,
    createdAt?: string | null,
    id: string,
    managed?: boolean | null,
    modelId: string,
    ownerId: string,
    reviewDate?: string | null,
    snapshotId?: string | null,
    status?: string | null,
    submittedOn?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type CreateSessionMutationVariables = {
  condition?: ModelSessionConditionInput | null,
  input: CreateSessionInput,
};

export type CreateSessionMutation = {
  createSession?:  {
    __typename: "Session",
    accountId: string,
    createdAt?: string | null,
    duration?: number | null,
    id: string,
    ownerId: string,
    sessionDate?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type CreateSnapshotMutationVariables = {
  condition?: ModelSnapshotConditionInput | null,
  input: CreateSnapshotInput,
};

export type CreateSnapshotMutation = {
  createSnapshot?:  {
    __typename: "Snapshot",
    accountId: string,
    archived?: boolean | null,
    createdAt?: string | null,
    date: string,
    description?: string | null,
    details?: string | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    snapshotType?: SnapshotType | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateTaxMutationVariables = {
  condition?: ModelTaxConditionInput | null,
  input: CreateTaxInput,
};

export type CreateTaxMutation = {
  createTax?:  {
    __typename: "Tax",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    taxType?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateTaxValueMutationVariables = {
  condition?: ModelTaxValueConditionInput | null,
  input: CreateTaxValueInput,
};

export type CreateTaxValueMutation = {
  createTaxValue?:  {
    __typename: "TaxValue",
    accountId: string,
    createdAt?: string | null,
    id: string,
    key: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
    value: number,
    year: number,
  } | null,
};

export type CreateUserMutationVariables = {
  condition?: ModelUserConditionInput | null,
  input: CreateUserInput,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    account?:  {
      __typename: "Account",
      address?: string | null,
      city?: string | null,
      createdAt?: string | null,
      id: string,
      name: string,
      ownerId?: string | null,
      postalCode?: string | null,
      state?: string | null,
      updatedAt?: string | null,
    } | null,
    accountId: string,
    advisorAccess?: boolean | null,
    advisorModelId?: string | null,
    advisorPrimaryModelId?: string | null,
    cancelledOn?: string | null,
    clientOn?: string | null,
    createdAt?: string | null,
    currentModelId?: string | null,
    currentPlanId?: string | null,
    customerId?: string | null,
    deletedOn?: string | null,
    deletedReason?: string | null,
    email: string,
    emailVerified?: boolean | null,
    endDate?: string | null,
    firstName: string,
    id: string,
    lastAccess?: string | null,
    lastName: string,
    mfaPreference?: string | null,
    migrateStatus?: string | null,
    migratedOn?: string | null,
    models?:  {
      __typename: "ModelModelConnection",
      nextToken?: string | null,
    } | null,
    phone?: string | null,
    phoneVerified?: boolean | null,
    primaryModelId?: string | null,
    referrer?: string | null,
    referrerDetails?: string | null,
    reviews?:  {
      __typename: "ModelReviewConnection",
      nextToken?: string | null,
    } | null,
    role: UserRole,
    sessionCount?: number | null,
    sessions?:  {
      __typename: "ModelSessionConnection",
      nextToken?: string | null,
    } | null,
    settings?:  {
      __typename: "ModelUserSettingConnection",
      nextToken?: string | null,
    } | null,
    startDate?: string | null,
    subscribedOn?: string | null,
    trialEndDate?: string | null,
    updatedAt?: string | null,
    userStatus: UserStatus,
    userType: UserType,
  } | null,
};

export type CreateUserInviteMutationVariables = {
  condition?: ModelUserInviteConditionInput | null,
  input: CreateUserInviteInput,
};

export type CreateUserInviteMutation = {
  createUserInvite?:  {
    __typename: "UserInvite",
    accountId: string,
    createdAt?: string | null,
    email: string,
    firstName: string,
    id: string,
    invitedOn: string,
    lastName: string,
    role: UserRole,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type CreateUserSettingMutationVariables = {
  condition?: ModelUserSettingConditionInput | null,
  input: CreateUserSettingInput,
};

export type CreateUserSettingMutation = {
  createUserSetting?:  {
    __typename: "UserSetting",
    accountId: string,
    createdAt?: string | null,
    description?: string | null,
    id: string,
    name: string,
    ownerId: string,
    settingType?: string | null,
    settings?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type DeleteAccountMutationVariables = {
  condition?: ModelAccountConditionInput | null,
  input: DeleteAccountInput,
};

export type DeleteAccountMutation = {
  deleteAccount?:  {
    __typename: "Account",
    address?: string | null,
    city?: string | null,
    createdAt?: string | null,
    id: string,
    name: string,
    ownerId?: string | null,
    postalCode?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteAssetMutationVariables = {
  condition?: ModelAssetConditionInput | null,
  input: DeleteAssetInput,
};

export type DeleteAssetMutation = {
  deleteAsset?:  {
    __typename: "Asset",
    accountId: string,
    archived?: boolean | null,
    assetCategory?: number | null,
    assetIncome?:  {
      __typename: "AssetIncome",
      basis?: number | null,
      rateTotal?: number | null,
      units?: number | null,
    } | null,
    assetIncomeDate?: string | null,
    assetType?: number | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    inheritedYear?: number | null,
    managed?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    netWorthExcluded?: boolean | null,
    notes?: string | null,
    originalOwnerBirthYear?: number | null,
    ownerId?: string | null,
    priorEoYBalance?: number | null,
    rateLock?: boolean | null,
    returnRate?: number | null,
    risk?: number | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
    withdrawalOrder?: number | null,
    withdrawalsYTD?: number | null,
  } | null,
};

export type DeleteAssetCategoryMutationVariables = {
  condition?: ModelAssetCategoryConditionInput | null,
  input: DeleteAssetCategoryInput,
};

export type DeleteAssetCategoryMutation = {
  deleteAssetCategory?:  {
    __typename: "AssetCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteAssetConversionMutationVariables = {
  condition?: ModelAssetConversionConditionInput | null,
  input: DeleteAssetConversionInput,
};

export type DeleteAssetConversionMutation = {
  deleteAssetConversion?:  {
    __typename: "AssetConversion",
    accountId: string,
    amount?: number | null,
    archived?: boolean | null,
    completedAt?: string | null,
    conversionType?: string | null,
    createdAt?: string | null,
    description?: string | null,
    dstAssetId: string,
    id: string,
    incomeType?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nonTaxableAmount?: number | null,
    percent?: number | null,
    sortOrder?: number | null,
    srcAssetId: string,
    taxableAmount?: number | null,
    updatedAt?: string | null,
    userId: string,
    year?: number | null,
  } | null,
};

export type DeleteAssetTypeMutationVariables = {
  condition?: ModelAssetTypeConditionInput | null,
  input: DeleteAssetTypeInput,
};

export type DeleteAssetTypeMutation = {
  deleteAssetType?:  {
    __typename: "AssetType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type DeleteDeductionMutationVariables = {
  condition?: ModelDeductionConditionInput | null,
  input: DeleteDeductionInput,
};

export type DeleteDeductionMutation = {
  deleteDeduction?:  {
    __typename: "Deduction",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    deductionType?: number | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteExpenseMutationVariables = {
  condition?: ModelExpenseConditionInput | null,
  input: DeleteExpenseInput,
};

export type DeleteExpenseMutation = {
  deleteExpense?:  {
    __typename: "Expense",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    discretionary?: boolean | null,
    end?: string | null,
    endDate?: string | null,
    expenseCategory?: number | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    liabilityId?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteExpenseCategoryMutationVariables = {
  condition?: ModelExpenseCategoryConditionInput | null,
  input: DeleteExpenseCategoryInput,
};

export type DeleteExpenseCategoryMutation = {
  deleteExpenseCategory?:  {
    __typename: "ExpenseCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteIncomeMutationVariables = {
  condition?: ModelIncomeConditionInput | null,
  input: DeleteIncomeInput,
};

export type DeleteIncomeMutation = {
  deleteIncome?:  {
    __typename: "Income",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    excludeFromNIIT?: boolean | null,
    grossAmount?: number | null,
    id: string,
    imputed?: boolean | null,
    incomeType?: number | null,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    survivorPercent?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteIncomeTypeMutationVariables = {
  condition?: ModelIncomeTypeConditionInput | null,
  input: DeleteIncomeTypeInput,
};

export type DeleteIncomeTypeMutation = {
  deleteIncomeType?:  {
    __typename: "IncomeType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type DeleteLiabilityMutationVariables = {
  condition?: ModelLiabilityConditionInput | null,
  input: DeleteLiabilityInput,
};

export type DeleteLiabilityMutation = {
  deleteLiability?:  {
    __typename: "Liability",
    accountId: string,
    archived?: boolean | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    interestRate?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    payoffDate?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteMilestoneMutationVariables = {
  condition?: ModelMilestoneConditionInput | null,
  input: DeleteMilestoneInput,
};

export type DeleteMilestoneMutation = {
  deleteMilestone?:  {
    __typename: "Milestone",
    accountId: string,
    age?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    date?: string | null,
    description?: string | null,
    id: string,
    label?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteModelMutationVariables = {
  condition?: ModelModelConditionInput | null,
  input: DeleteModelInput,
};

export type DeleteModelMutation = {
  deleteModel?:  {
    __typename: "Model",
    accountId: string,
    advisorCreated?: boolean | null,
    archived?: boolean | null,
    assetConversions?:  {
      __typename: "ModelAssetConversionConnection",
      nextToken?: string | null,
    } | null,
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    clientAccess?: ClientAccess | null,
    createdAt?: string | null,
    deductions?:  {
      __typename: "ModelDeductionConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    expenses?:  {
      __typename: "ModelExpenseConnection",
      nextToken?: string | null,
    } | null,
    id: string,
    incomes?:  {
      __typename: "ModelIncomeConnection",
      nextToken?: string | null,
    } | null,
    liabilities?:  {
      __typename: "ModelLiabilityConnection",
      nextToken?: string | null,
    } | null,
    milestones?:  {
      __typename: "ModelMilestoneConnection",
      nextToken?: string | null,
    } | null,
    name: string,
    ownerId: string,
    persons?:  {
      __typename: "ModelPersonConnection",
      nextToken?: string | null,
    } | null,
    plans?:  {
      __typename: "ModelPlanConnection",
      nextToken?: string | null,
    } | null,
    settings?: string | null,
    snapshots?:  {
      __typename: "ModelSnapshotConnection",
      nextToken?: string | null,
    } | null,
    startedAt?: string | null,
    taxValues?:  {
      __typename: "ModelTaxValueConnection",
      nextToken?: string | null,
    } | null,
    taxes?:  {
      __typename: "ModelTaxConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type DeletePersonMutationVariables = {
  condition?: ModelPersonConditionInput | null,
  input: DeletePersonInput,
};

export type DeletePersonMutation = {
  deletePerson?:  {
    __typename: "Person",
    accountId: string,
    birthDate?: string | null,
    createdAt?: string | null,
    gender?: Gender | null,
    hereditaryAdjust?: number | null,
    id: string,
    lifeExpectancy?: number | null,
    maritalStatus?: MaritalStatus | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nickname?: string | null,
    retireDate?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeletePlanMutationVariables = {
  condition?: ModelPlanConditionInput | null,
  input: DeletePlanInput,
};

export type DeletePlanMutation = {
  deletePlan?:  {
    __typename: "Plan",
    accountId: string,
    archived?: boolean | null,
    changes?:  {
      __typename: "ModelPlanChangeConnection",
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    default?: boolean | null,
    description?: string | null,
    enabled?: boolean | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    name?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeletePlanChangeMutationVariables = {
  condition?: ModelPlanChangeConditionInput | null,
  input: DeletePlanChangeInput,
};

export type DeletePlanChangeMutation = {
  deletePlanChange?:  {
    __typename: "PlanChange",
    accountId: string,
    changeType: string,
    createdAt?: string | null,
    description?: string | null,
    details?: string | null,
    enabled?: boolean | null,
    id: string,
    modelId: string,
    name: string,
    plan?:  {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null,
    planId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteReviewMutationVariables = {
  condition?: ModelReviewConditionInput | null,
  input: DeleteReviewInput,
};

export type DeleteReviewMutation = {
  deleteReview?:  {
    __typename: "Review",
    accountId: string,
    archived?: boolean | null,
    baseSnapId?: string | null,
    checklist?: string | null,
    createdAt?: string | null,
    id: string,
    managed?: boolean | null,
    modelId: string,
    ownerId: string,
    reviewDate?: string | null,
    snapshotId?: string | null,
    status?: string | null,
    submittedOn?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type DeleteSessionMutationVariables = {
  condition?: ModelSessionConditionInput | null,
  input: DeleteSessionInput,
};

export type DeleteSessionMutation = {
  deleteSession?:  {
    __typename: "Session",
    accountId: string,
    createdAt?: string | null,
    duration?: number | null,
    id: string,
    ownerId: string,
    sessionDate?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type DeleteSnapshotMutationVariables = {
  condition?: ModelSnapshotConditionInput | null,
  input: DeleteSnapshotInput,
};

export type DeleteSnapshotMutation = {
  deleteSnapshot?:  {
    __typename: "Snapshot",
    accountId: string,
    archived?: boolean | null,
    createdAt?: string | null,
    date: string,
    description?: string | null,
    details?: string | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    snapshotType?: SnapshotType | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteTaxMutationVariables = {
  condition?: ModelTaxConditionInput | null,
  input: DeleteTaxInput,
};

export type DeleteTaxMutation = {
  deleteTax?:  {
    __typename: "Tax",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    taxType?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteTaxValueMutationVariables = {
  condition?: ModelTaxValueConditionInput | null,
  input: DeleteTaxValueInput,
};

export type DeleteTaxValueMutation = {
  deleteTaxValue?:  {
    __typename: "TaxValue",
    accountId: string,
    createdAt?: string | null,
    id: string,
    key: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
    value: number,
    year: number,
  } | null,
};

export type DeleteUserMutationVariables = {
  condition?: ModelUserConditionInput | null,
  input: DeleteUserInput,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    account?:  {
      __typename: "Account",
      address?: string | null,
      city?: string | null,
      createdAt?: string | null,
      id: string,
      name: string,
      ownerId?: string | null,
      postalCode?: string | null,
      state?: string | null,
      updatedAt?: string | null,
    } | null,
    accountId: string,
    advisorAccess?: boolean | null,
    advisorModelId?: string | null,
    advisorPrimaryModelId?: string | null,
    cancelledOn?: string | null,
    clientOn?: string | null,
    createdAt?: string | null,
    currentModelId?: string | null,
    currentPlanId?: string | null,
    customerId?: string | null,
    deletedOn?: string | null,
    deletedReason?: string | null,
    email: string,
    emailVerified?: boolean | null,
    endDate?: string | null,
    firstName: string,
    id: string,
    lastAccess?: string | null,
    lastName: string,
    mfaPreference?: string | null,
    migrateStatus?: string | null,
    migratedOn?: string | null,
    models?:  {
      __typename: "ModelModelConnection",
      nextToken?: string | null,
    } | null,
    phone?: string | null,
    phoneVerified?: boolean | null,
    primaryModelId?: string | null,
    referrer?: string | null,
    referrerDetails?: string | null,
    reviews?:  {
      __typename: "ModelReviewConnection",
      nextToken?: string | null,
    } | null,
    role: UserRole,
    sessionCount?: number | null,
    sessions?:  {
      __typename: "ModelSessionConnection",
      nextToken?: string | null,
    } | null,
    settings?:  {
      __typename: "ModelUserSettingConnection",
      nextToken?: string | null,
    } | null,
    startDate?: string | null,
    subscribedOn?: string | null,
    trialEndDate?: string | null,
    updatedAt?: string | null,
    userStatus: UserStatus,
    userType: UserType,
  } | null,
};

export type DeleteUserInviteMutationVariables = {
  condition?: ModelUserInviteConditionInput | null,
  input: DeleteUserInviteInput,
};

export type DeleteUserInviteMutation = {
  deleteUserInvite?:  {
    __typename: "UserInvite",
    accountId: string,
    createdAt?: string | null,
    email: string,
    firstName: string,
    id: string,
    invitedOn: string,
    lastName: string,
    role: UserRole,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type DeleteUserSettingMutationVariables = {
  condition?: ModelUserSettingConditionInput | null,
  input: DeleteUserSettingInput,
};

export type DeleteUserSettingMutation = {
  deleteUserSetting?:  {
    __typename: "UserSetting",
    accountId: string,
    createdAt?: string | null,
    description?: string | null,
    id: string,
    name: string,
    ownerId: string,
    settingType?: string | null,
    settings?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type UpdateAccountMutationVariables = {
  condition?: ModelAccountConditionInput | null,
  input: UpdateAccountInput,
};

export type UpdateAccountMutation = {
  updateAccount?:  {
    __typename: "Account",
    address?: string | null,
    city?: string | null,
    createdAt?: string | null,
    id: string,
    name: string,
    ownerId?: string | null,
    postalCode?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateAssetMutationVariables = {
  condition?: ModelAssetConditionInput | null,
  input: UpdateAssetInput,
};

export type UpdateAssetMutation = {
  updateAsset?:  {
    __typename: "Asset",
    accountId: string,
    archived?: boolean | null,
    assetCategory?: number | null,
    assetIncome?:  {
      __typename: "AssetIncome",
      basis?: number | null,
      rateTotal?: number | null,
      units?: number | null,
    } | null,
    assetIncomeDate?: string | null,
    assetType?: number | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    inheritedYear?: number | null,
    managed?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    netWorthExcluded?: boolean | null,
    notes?: string | null,
    originalOwnerBirthYear?: number | null,
    ownerId?: string | null,
    priorEoYBalance?: number | null,
    rateLock?: boolean | null,
    returnRate?: number | null,
    risk?: number | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
    withdrawalOrder?: number | null,
    withdrawalsYTD?: number | null,
  } | null,
};

export type UpdateAssetCategoryMutationVariables = {
  condition?: ModelAssetCategoryConditionInput | null,
  input: UpdateAssetCategoryInput,
};

export type UpdateAssetCategoryMutation = {
  updateAssetCategory?:  {
    __typename: "AssetCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateAssetConversionMutationVariables = {
  condition?: ModelAssetConversionConditionInput | null,
  input: UpdateAssetConversionInput,
};

export type UpdateAssetConversionMutation = {
  updateAssetConversion?:  {
    __typename: "AssetConversion",
    accountId: string,
    amount?: number | null,
    archived?: boolean | null,
    completedAt?: string | null,
    conversionType?: string | null,
    createdAt?: string | null,
    description?: string | null,
    dstAssetId: string,
    id: string,
    incomeType?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nonTaxableAmount?: number | null,
    percent?: number | null,
    sortOrder?: number | null,
    srcAssetId: string,
    taxableAmount?: number | null,
    updatedAt?: string | null,
    userId: string,
    year?: number | null,
  } | null,
};

export type UpdateAssetTypeMutationVariables = {
  condition?: ModelAssetTypeConditionInput | null,
  input: UpdateAssetTypeInput,
};

export type UpdateAssetTypeMutation = {
  updateAssetType?:  {
    __typename: "AssetType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type UpdateDeductionMutationVariables = {
  condition?: ModelDeductionConditionInput | null,
  input: UpdateDeductionInput,
};

export type UpdateDeductionMutation = {
  updateDeduction?:  {
    __typename: "Deduction",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    deductionType?: number | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateExpenseMutationVariables = {
  condition?: ModelExpenseConditionInput | null,
  input: UpdateExpenseInput,
};

export type UpdateExpenseMutation = {
  updateExpense?:  {
    __typename: "Expense",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    discretionary?: boolean | null,
    end?: string | null,
    endDate?: string | null,
    expenseCategory?: number | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    liabilityId?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateExpenseCategoryMutationVariables = {
  condition?: ModelExpenseCategoryConditionInput | null,
  input: UpdateExpenseCategoryInput,
};

export type UpdateExpenseCategoryMutation = {
  updateExpenseCategory?:  {
    __typename: "ExpenseCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateIncomeMutationVariables = {
  condition?: ModelIncomeConditionInput | null,
  input: UpdateIncomeInput,
};

export type UpdateIncomeMutation = {
  updateIncome?:  {
    __typename: "Income",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    excludeFromNIIT?: boolean | null,
    grossAmount?: number | null,
    id: string,
    imputed?: boolean | null,
    incomeType?: number | null,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    survivorPercent?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateIncomeTypeMutationVariables = {
  condition?: ModelIncomeTypeConditionInput | null,
  input: UpdateIncomeTypeInput,
};

export type UpdateIncomeTypeMutation = {
  updateIncomeType?:  {
    __typename: "IncomeType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type UpdateLiabilityMutationVariables = {
  condition?: ModelLiabilityConditionInput | null,
  input: UpdateLiabilityInput,
};

export type UpdateLiabilityMutation = {
  updateLiability?:  {
    __typename: "Liability",
    accountId: string,
    archived?: boolean | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    interestRate?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    payoffDate?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateMilestoneMutationVariables = {
  condition?: ModelMilestoneConditionInput | null,
  input: UpdateMilestoneInput,
};

export type UpdateMilestoneMutation = {
  updateMilestone?:  {
    __typename: "Milestone",
    accountId: string,
    age?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    date?: string | null,
    description?: string | null,
    id: string,
    label?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateModelMutationVariables = {
  condition?: ModelModelConditionInput | null,
  input: UpdateModelInput,
};

export type UpdateModelMutation = {
  updateModel?:  {
    __typename: "Model",
    accountId: string,
    advisorCreated?: boolean | null,
    archived?: boolean | null,
    assetConversions?:  {
      __typename: "ModelAssetConversionConnection",
      nextToken?: string | null,
    } | null,
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    clientAccess?: ClientAccess | null,
    createdAt?: string | null,
    deductions?:  {
      __typename: "ModelDeductionConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    expenses?:  {
      __typename: "ModelExpenseConnection",
      nextToken?: string | null,
    } | null,
    id: string,
    incomes?:  {
      __typename: "ModelIncomeConnection",
      nextToken?: string | null,
    } | null,
    liabilities?:  {
      __typename: "ModelLiabilityConnection",
      nextToken?: string | null,
    } | null,
    milestones?:  {
      __typename: "ModelMilestoneConnection",
      nextToken?: string | null,
    } | null,
    name: string,
    ownerId: string,
    persons?:  {
      __typename: "ModelPersonConnection",
      nextToken?: string | null,
    } | null,
    plans?:  {
      __typename: "ModelPlanConnection",
      nextToken?: string | null,
    } | null,
    settings?: string | null,
    snapshots?:  {
      __typename: "ModelSnapshotConnection",
      nextToken?: string | null,
    } | null,
    startedAt?: string | null,
    taxValues?:  {
      __typename: "ModelTaxValueConnection",
      nextToken?: string | null,
    } | null,
    taxes?:  {
      __typename: "ModelTaxConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type UpdatePersonMutationVariables = {
  condition?: ModelPersonConditionInput | null,
  input: UpdatePersonInput,
};

export type UpdatePersonMutation = {
  updatePerson?:  {
    __typename: "Person",
    accountId: string,
    birthDate?: string | null,
    createdAt?: string | null,
    gender?: Gender | null,
    hereditaryAdjust?: number | null,
    id: string,
    lifeExpectancy?: number | null,
    maritalStatus?: MaritalStatus | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nickname?: string | null,
    retireDate?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdatePlanMutationVariables = {
  condition?: ModelPlanConditionInput | null,
  input: UpdatePlanInput,
};

export type UpdatePlanMutation = {
  updatePlan?:  {
    __typename: "Plan",
    accountId: string,
    archived?: boolean | null,
    changes?:  {
      __typename: "ModelPlanChangeConnection",
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    default?: boolean | null,
    description?: string | null,
    enabled?: boolean | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    name?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdatePlanChangeMutationVariables = {
  condition?: ModelPlanChangeConditionInput | null,
  input: UpdatePlanChangeInput,
};

export type UpdatePlanChangeMutation = {
  updatePlanChange?:  {
    __typename: "PlanChange",
    accountId: string,
    changeType: string,
    createdAt?: string | null,
    description?: string | null,
    details?: string | null,
    enabled?: boolean | null,
    id: string,
    modelId: string,
    name: string,
    plan?:  {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null,
    planId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateReviewMutationVariables = {
  condition?: ModelReviewConditionInput | null,
  input: UpdateReviewInput,
};

export type UpdateReviewMutation = {
  updateReview?:  {
    __typename: "Review",
    accountId: string,
    archived?: boolean | null,
    baseSnapId?: string | null,
    checklist?: string | null,
    createdAt?: string | null,
    id: string,
    managed?: boolean | null,
    modelId: string,
    ownerId: string,
    reviewDate?: string | null,
    snapshotId?: string | null,
    status?: string | null,
    submittedOn?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type UpdateSessionMutationVariables = {
  condition?: ModelSessionConditionInput | null,
  input: UpdateSessionInput,
};

export type UpdateSessionMutation = {
  updateSession?:  {
    __typename: "Session",
    accountId: string,
    createdAt?: string | null,
    duration?: number | null,
    id: string,
    ownerId: string,
    sessionDate?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type UpdateSnapshotMutationVariables = {
  condition?: ModelSnapshotConditionInput | null,
  input: UpdateSnapshotInput,
};

export type UpdateSnapshotMutation = {
  updateSnapshot?:  {
    __typename: "Snapshot",
    accountId: string,
    archived?: boolean | null,
    createdAt?: string | null,
    date: string,
    description?: string | null,
    details?: string | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    snapshotType?: SnapshotType | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateTaxMutationVariables = {
  condition?: ModelTaxConditionInput | null,
  input: UpdateTaxInput,
};

export type UpdateTaxMutation = {
  updateTax?:  {
    __typename: "Tax",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    taxType?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateTaxValueMutationVariables = {
  condition?: ModelTaxValueConditionInput | null,
  input: UpdateTaxValueInput,
};

export type UpdateTaxValueMutation = {
  updateTaxValue?:  {
    __typename: "TaxValue",
    accountId: string,
    createdAt?: string | null,
    id: string,
    key: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
    value: number,
    year: number,
  } | null,
};

export type UpdateUserMutationVariables = {
  condition?: ModelUserConditionInput | null,
  input: UpdateUserInput,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    account?:  {
      __typename: "Account",
      address?: string | null,
      city?: string | null,
      createdAt?: string | null,
      id: string,
      name: string,
      ownerId?: string | null,
      postalCode?: string | null,
      state?: string | null,
      updatedAt?: string | null,
    } | null,
    accountId: string,
    advisorAccess?: boolean | null,
    advisorModelId?: string | null,
    advisorPrimaryModelId?: string | null,
    cancelledOn?: string | null,
    clientOn?: string | null,
    createdAt?: string | null,
    currentModelId?: string | null,
    currentPlanId?: string | null,
    customerId?: string | null,
    deletedOn?: string | null,
    deletedReason?: string | null,
    email: string,
    emailVerified?: boolean | null,
    endDate?: string | null,
    firstName: string,
    id: string,
    lastAccess?: string | null,
    lastName: string,
    mfaPreference?: string | null,
    migrateStatus?: string | null,
    migratedOn?: string | null,
    models?:  {
      __typename: "ModelModelConnection",
      nextToken?: string | null,
    } | null,
    phone?: string | null,
    phoneVerified?: boolean | null,
    primaryModelId?: string | null,
    referrer?: string | null,
    referrerDetails?: string | null,
    reviews?:  {
      __typename: "ModelReviewConnection",
      nextToken?: string | null,
    } | null,
    role: UserRole,
    sessionCount?: number | null,
    sessions?:  {
      __typename: "ModelSessionConnection",
      nextToken?: string | null,
    } | null,
    settings?:  {
      __typename: "ModelUserSettingConnection",
      nextToken?: string | null,
    } | null,
    startDate?: string | null,
    subscribedOn?: string | null,
    trialEndDate?: string | null,
    updatedAt?: string | null,
    userStatus: UserStatus,
    userType: UserType,
  } | null,
};

export type UpdateUserInviteMutationVariables = {
  condition?: ModelUserInviteConditionInput | null,
  input: UpdateUserInviteInput,
};

export type UpdateUserInviteMutation = {
  updateUserInvite?:  {
    __typename: "UserInvite",
    accountId: string,
    createdAt?: string | null,
    email: string,
    firstName: string,
    id: string,
    invitedOn: string,
    lastName: string,
    role: UserRole,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type UpdateUserSettingMutationVariables = {
  condition?: ModelUserSettingConditionInput | null,
  input: UpdateUserSettingInput,
};

export type UpdateUserSettingMutation = {
  updateUserSetting?:  {
    __typename: "UserSetting",
    accountId: string,
    createdAt?: string | null,
    description?: string | null,
    id: string,
    name: string,
    ownerId: string,
    settingType?: string | null,
    settings?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnCreateAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateAccountSubscription = {
  onCreateAccount?:  {
    __typename: "Account",
    address?: string | null,
    city?: string | null,
    createdAt?: string | null,
    id: string,
    name: string,
    ownerId?: string | null,
    postalCode?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateAssetSubscriptionVariables = {
  filter?: ModelSubscriptionAssetFilterInput | null,
  userId?: string | null,
};

export type OnCreateAssetSubscription = {
  onCreateAsset?:  {
    __typename: "Asset",
    accountId: string,
    archived?: boolean | null,
    assetCategory?: number | null,
    assetIncome?:  {
      __typename: "AssetIncome",
      basis?: number | null,
      rateTotal?: number | null,
      units?: number | null,
    } | null,
    assetIncomeDate?: string | null,
    assetType?: number | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    inheritedYear?: number | null,
    managed?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    netWorthExcluded?: boolean | null,
    notes?: string | null,
    originalOwnerBirthYear?: number | null,
    ownerId?: string | null,
    priorEoYBalance?: number | null,
    rateLock?: boolean | null,
    returnRate?: number | null,
    risk?: number | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
    withdrawalOrder?: number | null,
    withdrawalsYTD?: number | null,
  } | null,
};

export type OnCreateAssetCategorySubscriptionVariables = {
  filter?: ModelSubscriptionAssetCategoryFilterInput | null,
};

export type OnCreateAssetCategorySubscription = {
  onCreateAssetCategory?:  {
    __typename: "AssetCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAssetConversionSubscriptionVariables = {
  filter?: ModelSubscriptionAssetConversionFilterInput | null,
  userId?: string | null,
};

export type OnCreateAssetConversionSubscription = {
  onCreateAssetConversion?:  {
    __typename: "AssetConversion",
    accountId: string,
    amount?: number | null,
    archived?: boolean | null,
    completedAt?: string | null,
    conversionType?: string | null,
    createdAt?: string | null,
    description?: string | null,
    dstAssetId: string,
    id: string,
    incomeType?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nonTaxableAmount?: number | null,
    percent?: number | null,
    sortOrder?: number | null,
    srcAssetId: string,
    taxableAmount?: number | null,
    updatedAt?: string | null,
    userId: string,
    year?: number | null,
  } | null,
};

export type OnCreateAssetTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAssetTypeFilterInput | null,
};

export type OnCreateAssetTypeSubscription = {
  onCreateAssetType?:  {
    __typename: "AssetType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateDeductionSubscriptionVariables = {
  filter?: ModelSubscriptionDeductionFilterInput | null,
  userId?: string | null,
};

export type OnCreateDeductionSubscription = {
  onCreateDeduction?:  {
    __typename: "Deduction",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    deductionType?: number | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateExpenseSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseFilterInput | null,
  userId?: string | null,
};

export type OnCreateExpenseSubscription = {
  onCreateExpense?:  {
    __typename: "Expense",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    discretionary?: boolean | null,
    end?: string | null,
    endDate?: string | null,
    expenseCategory?: number | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    liabilityId?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateExpenseCategorySubscriptionVariables = {
  filter?: ModelSubscriptionExpenseCategoryFilterInput | null,
};

export type OnCreateExpenseCategorySubscription = {
  onCreateExpenseCategory?:  {
    __typename: "ExpenseCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateIncomeSubscriptionVariables = {
  filter?: ModelSubscriptionIncomeFilterInput | null,
  userId?: string | null,
};

export type OnCreateIncomeSubscription = {
  onCreateIncome?:  {
    __typename: "Income",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    excludeFromNIIT?: boolean | null,
    grossAmount?: number | null,
    id: string,
    imputed?: boolean | null,
    incomeType?: number | null,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    survivorPercent?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateIncomeTypeSubscriptionVariables = {
  filter?: ModelSubscriptionIncomeTypeFilterInput | null,
};

export type OnCreateIncomeTypeSubscription = {
  onCreateIncomeType?:  {
    __typename: "IncomeType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateLiabilitySubscriptionVariables = {
  filter?: ModelSubscriptionLiabilityFilterInput | null,
  userId?: string | null,
};

export type OnCreateLiabilitySubscription = {
  onCreateLiability?:  {
    __typename: "Liability",
    accountId: string,
    archived?: boolean | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    interestRate?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    payoffDate?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateMilestoneSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneFilterInput | null,
  userId?: string | null,
};

export type OnCreateMilestoneSubscription = {
  onCreateMilestone?:  {
    __typename: "Milestone",
    accountId: string,
    age?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    date?: string | null,
    description?: string | null,
    id: string,
    label?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateModelSubscriptionVariables = {
  filter?: ModelSubscriptionModelFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateModelSubscription = {
  onCreateModel?:  {
    __typename: "Model",
    accountId: string,
    advisorCreated?: boolean | null,
    archived?: boolean | null,
    assetConversions?:  {
      __typename: "ModelAssetConversionConnection",
      nextToken?: string | null,
    } | null,
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    clientAccess?: ClientAccess | null,
    createdAt?: string | null,
    deductions?:  {
      __typename: "ModelDeductionConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    expenses?:  {
      __typename: "ModelExpenseConnection",
      nextToken?: string | null,
    } | null,
    id: string,
    incomes?:  {
      __typename: "ModelIncomeConnection",
      nextToken?: string | null,
    } | null,
    liabilities?:  {
      __typename: "ModelLiabilityConnection",
      nextToken?: string | null,
    } | null,
    milestones?:  {
      __typename: "ModelMilestoneConnection",
      nextToken?: string | null,
    } | null,
    name: string,
    ownerId: string,
    persons?:  {
      __typename: "ModelPersonConnection",
      nextToken?: string | null,
    } | null,
    plans?:  {
      __typename: "ModelPlanConnection",
      nextToken?: string | null,
    } | null,
    settings?: string | null,
    snapshots?:  {
      __typename: "ModelSnapshotConnection",
      nextToken?: string | null,
    } | null,
    startedAt?: string | null,
    taxValues?:  {
      __typename: "ModelTaxValueConnection",
      nextToken?: string | null,
    } | null,
    taxes?:  {
      __typename: "ModelTaxConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnCreatePersonSubscriptionVariables = {
  filter?: ModelSubscriptionPersonFilterInput | null,
  userId?: string | null,
};

export type OnCreatePersonSubscription = {
  onCreatePerson?:  {
    __typename: "Person",
    accountId: string,
    birthDate?: string | null,
    createdAt?: string | null,
    gender?: Gender | null,
    hereditaryAdjust?: number | null,
    id: string,
    lifeExpectancy?: number | null,
    maritalStatus?: MaritalStatus | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nickname?: string | null,
    retireDate?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreatePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
  userId?: string | null,
};

export type OnCreatePlanSubscription = {
  onCreatePlan?:  {
    __typename: "Plan",
    accountId: string,
    archived?: boolean | null,
    changes?:  {
      __typename: "ModelPlanChangeConnection",
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    default?: boolean | null,
    description?: string | null,
    enabled?: boolean | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    name?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreatePlanChangeSubscriptionVariables = {
  filter?: ModelSubscriptionPlanChangeFilterInput | null,
  userId?: string | null,
};

export type OnCreatePlanChangeSubscription = {
  onCreatePlanChange?:  {
    __typename: "PlanChange",
    accountId: string,
    changeType: string,
    createdAt?: string | null,
    description?: string | null,
    details?: string | null,
    enabled?: boolean | null,
    id: string,
    modelId: string,
    name: string,
    plan?:  {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null,
    planId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateReviewSubscriptionVariables = {
  filter?: ModelSubscriptionReviewFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateReviewSubscription = {
  onCreateReview?:  {
    __typename: "Review",
    accountId: string,
    archived?: boolean | null,
    baseSnapId?: string | null,
    checklist?: string | null,
    createdAt?: string | null,
    id: string,
    managed?: boolean | null,
    modelId: string,
    ownerId: string,
    reviewDate?: string | null,
    snapshotId?: string | null,
    status?: string | null,
    submittedOn?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnCreateSessionSubscriptionVariables = {
  filter?: ModelSubscriptionSessionFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateSessionSubscription = {
  onCreateSession?:  {
    __typename: "Session",
    accountId: string,
    createdAt?: string | null,
    duration?: number | null,
    id: string,
    ownerId: string,
    sessionDate?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnCreateSnapshotSubscriptionVariables = {
  filter?: ModelSubscriptionSnapshotFilterInput | null,
  userId?: string | null,
};

export type OnCreateSnapshotSubscription = {
  onCreateSnapshot?:  {
    __typename: "Snapshot",
    accountId: string,
    archived?: boolean | null,
    createdAt?: string | null,
    date: string,
    description?: string | null,
    details?: string | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    snapshotType?: SnapshotType | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateTaxSubscriptionVariables = {
  filter?: ModelSubscriptionTaxFilterInput | null,
  userId?: string | null,
};

export type OnCreateTaxSubscription = {
  onCreateTax?:  {
    __typename: "Tax",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    taxType?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateTaxValueSubscriptionVariables = {
  filter?: ModelSubscriptionTaxValueFilterInput | null,
  userId?: string | null,
};

export type OnCreateTaxValueSubscription = {
  onCreateTaxValue?:  {
    __typename: "TaxValue",
    accountId: string,
    createdAt?: string | null,
    id: string,
    key: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
    value: number,
    year: number,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    account?:  {
      __typename: "Account",
      address?: string | null,
      city?: string | null,
      createdAt?: string | null,
      id: string,
      name: string,
      ownerId?: string | null,
      postalCode?: string | null,
      state?: string | null,
      updatedAt?: string | null,
    } | null,
    accountId: string,
    advisorAccess?: boolean | null,
    advisorModelId?: string | null,
    advisorPrimaryModelId?: string | null,
    cancelledOn?: string | null,
    clientOn?: string | null,
    createdAt?: string | null,
    currentModelId?: string | null,
    currentPlanId?: string | null,
    customerId?: string | null,
    deletedOn?: string | null,
    deletedReason?: string | null,
    email: string,
    emailVerified?: boolean | null,
    endDate?: string | null,
    firstName: string,
    id: string,
    lastAccess?: string | null,
    lastName: string,
    mfaPreference?: string | null,
    migrateStatus?: string | null,
    migratedOn?: string | null,
    models?:  {
      __typename: "ModelModelConnection",
      nextToken?: string | null,
    } | null,
    phone?: string | null,
    phoneVerified?: boolean | null,
    primaryModelId?: string | null,
    referrer?: string | null,
    referrerDetails?: string | null,
    reviews?:  {
      __typename: "ModelReviewConnection",
      nextToken?: string | null,
    } | null,
    role: UserRole,
    sessionCount?: number | null,
    sessions?:  {
      __typename: "ModelSessionConnection",
      nextToken?: string | null,
    } | null,
    settings?:  {
      __typename: "ModelUserSettingConnection",
      nextToken?: string | null,
    } | null,
    startDate?: string | null,
    subscribedOn?: string | null,
    trialEndDate?: string | null,
    updatedAt?: string | null,
    userStatus: UserStatus,
    userType: UserType,
  } | null,
};

export type OnCreateUserInviteSubscriptionVariables = {
  filter?: ModelSubscriptionUserInviteFilterInput | null,
  userId?: string | null,
};

export type OnCreateUserInviteSubscription = {
  onCreateUserInvite?:  {
    __typename: "UserInvite",
    accountId: string,
    createdAt?: string | null,
    email: string,
    firstName: string,
    id: string,
    invitedOn: string,
    lastName: string,
    role: UserRole,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnCreateUserSettingSubscriptionVariables = {
  filter?: ModelSubscriptionUserSettingFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateUserSettingSubscription = {
  onCreateUserSetting?:  {
    __typename: "UserSetting",
    accountId: string,
    createdAt?: string | null,
    description?: string | null,
    id: string,
    name: string,
    ownerId: string,
    settingType?: string | null,
    settings?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnDeleteAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteAccountSubscription = {
  onDeleteAccount?:  {
    __typename: "Account",
    address?: string | null,
    city?: string | null,
    createdAt?: string | null,
    id: string,
    name: string,
    ownerId?: string | null,
    postalCode?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteAssetSubscriptionVariables = {
  filter?: ModelSubscriptionAssetFilterInput | null,
  userId?: string | null,
};

export type OnDeleteAssetSubscription = {
  onDeleteAsset?:  {
    __typename: "Asset",
    accountId: string,
    archived?: boolean | null,
    assetCategory?: number | null,
    assetIncome?:  {
      __typename: "AssetIncome",
      basis?: number | null,
      rateTotal?: number | null,
      units?: number | null,
    } | null,
    assetIncomeDate?: string | null,
    assetType?: number | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    inheritedYear?: number | null,
    managed?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    netWorthExcluded?: boolean | null,
    notes?: string | null,
    originalOwnerBirthYear?: number | null,
    ownerId?: string | null,
    priorEoYBalance?: number | null,
    rateLock?: boolean | null,
    returnRate?: number | null,
    risk?: number | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
    withdrawalOrder?: number | null,
    withdrawalsYTD?: number | null,
  } | null,
};

export type OnDeleteAssetCategorySubscriptionVariables = {
  filter?: ModelSubscriptionAssetCategoryFilterInput | null,
};

export type OnDeleteAssetCategorySubscription = {
  onDeleteAssetCategory?:  {
    __typename: "AssetCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteAssetConversionSubscriptionVariables = {
  filter?: ModelSubscriptionAssetConversionFilterInput | null,
  userId?: string | null,
};

export type OnDeleteAssetConversionSubscription = {
  onDeleteAssetConversion?:  {
    __typename: "AssetConversion",
    accountId: string,
    amount?: number | null,
    archived?: boolean | null,
    completedAt?: string | null,
    conversionType?: string | null,
    createdAt?: string | null,
    description?: string | null,
    dstAssetId: string,
    id: string,
    incomeType?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nonTaxableAmount?: number | null,
    percent?: number | null,
    sortOrder?: number | null,
    srcAssetId: string,
    taxableAmount?: number | null,
    updatedAt?: string | null,
    userId: string,
    year?: number | null,
  } | null,
};

export type OnDeleteAssetTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAssetTypeFilterInput | null,
};

export type OnDeleteAssetTypeSubscription = {
  onDeleteAssetType?:  {
    __typename: "AssetType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteDeductionSubscriptionVariables = {
  filter?: ModelSubscriptionDeductionFilterInput | null,
  userId?: string | null,
};

export type OnDeleteDeductionSubscription = {
  onDeleteDeduction?:  {
    __typename: "Deduction",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    deductionType?: number | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteExpenseSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseFilterInput | null,
  userId?: string | null,
};

export type OnDeleteExpenseSubscription = {
  onDeleteExpense?:  {
    __typename: "Expense",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    discretionary?: boolean | null,
    end?: string | null,
    endDate?: string | null,
    expenseCategory?: number | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    liabilityId?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteExpenseCategorySubscriptionVariables = {
  filter?: ModelSubscriptionExpenseCategoryFilterInput | null,
};

export type OnDeleteExpenseCategorySubscription = {
  onDeleteExpenseCategory?:  {
    __typename: "ExpenseCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteIncomeSubscriptionVariables = {
  filter?: ModelSubscriptionIncomeFilterInput | null,
  userId?: string | null,
};

export type OnDeleteIncomeSubscription = {
  onDeleteIncome?:  {
    __typename: "Income",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    excludeFromNIIT?: boolean | null,
    grossAmount?: number | null,
    id: string,
    imputed?: boolean | null,
    incomeType?: number | null,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    survivorPercent?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteIncomeTypeSubscriptionVariables = {
  filter?: ModelSubscriptionIncomeTypeFilterInput | null,
};

export type OnDeleteIncomeTypeSubscription = {
  onDeleteIncomeType?:  {
    __typename: "IncomeType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteLiabilitySubscriptionVariables = {
  filter?: ModelSubscriptionLiabilityFilterInput | null,
  userId?: string | null,
};

export type OnDeleteLiabilitySubscription = {
  onDeleteLiability?:  {
    __typename: "Liability",
    accountId: string,
    archived?: boolean | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    interestRate?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    payoffDate?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteMilestoneSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneFilterInput | null,
  userId?: string | null,
};

export type OnDeleteMilestoneSubscription = {
  onDeleteMilestone?:  {
    __typename: "Milestone",
    accountId: string,
    age?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    date?: string | null,
    description?: string | null,
    id: string,
    label?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteModelSubscriptionVariables = {
  filter?: ModelSubscriptionModelFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteModelSubscription = {
  onDeleteModel?:  {
    __typename: "Model",
    accountId: string,
    advisorCreated?: boolean | null,
    archived?: boolean | null,
    assetConversions?:  {
      __typename: "ModelAssetConversionConnection",
      nextToken?: string | null,
    } | null,
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    clientAccess?: ClientAccess | null,
    createdAt?: string | null,
    deductions?:  {
      __typename: "ModelDeductionConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    expenses?:  {
      __typename: "ModelExpenseConnection",
      nextToken?: string | null,
    } | null,
    id: string,
    incomes?:  {
      __typename: "ModelIncomeConnection",
      nextToken?: string | null,
    } | null,
    liabilities?:  {
      __typename: "ModelLiabilityConnection",
      nextToken?: string | null,
    } | null,
    milestones?:  {
      __typename: "ModelMilestoneConnection",
      nextToken?: string | null,
    } | null,
    name: string,
    ownerId: string,
    persons?:  {
      __typename: "ModelPersonConnection",
      nextToken?: string | null,
    } | null,
    plans?:  {
      __typename: "ModelPlanConnection",
      nextToken?: string | null,
    } | null,
    settings?: string | null,
    snapshots?:  {
      __typename: "ModelSnapshotConnection",
      nextToken?: string | null,
    } | null,
    startedAt?: string | null,
    taxValues?:  {
      __typename: "ModelTaxValueConnection",
      nextToken?: string | null,
    } | null,
    taxes?:  {
      __typename: "ModelTaxConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnDeletePersonSubscriptionVariables = {
  filter?: ModelSubscriptionPersonFilterInput | null,
  userId?: string | null,
};

export type OnDeletePersonSubscription = {
  onDeletePerson?:  {
    __typename: "Person",
    accountId: string,
    birthDate?: string | null,
    createdAt?: string | null,
    gender?: Gender | null,
    hereditaryAdjust?: number | null,
    id: string,
    lifeExpectancy?: number | null,
    maritalStatus?: MaritalStatus | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nickname?: string | null,
    retireDate?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeletePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
  userId?: string | null,
};

export type OnDeletePlanSubscription = {
  onDeletePlan?:  {
    __typename: "Plan",
    accountId: string,
    archived?: boolean | null,
    changes?:  {
      __typename: "ModelPlanChangeConnection",
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    default?: boolean | null,
    description?: string | null,
    enabled?: boolean | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    name?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeletePlanChangeSubscriptionVariables = {
  filter?: ModelSubscriptionPlanChangeFilterInput | null,
  userId?: string | null,
};

export type OnDeletePlanChangeSubscription = {
  onDeletePlanChange?:  {
    __typename: "PlanChange",
    accountId: string,
    changeType: string,
    createdAt?: string | null,
    description?: string | null,
    details?: string | null,
    enabled?: boolean | null,
    id: string,
    modelId: string,
    name: string,
    plan?:  {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null,
    planId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteReviewSubscriptionVariables = {
  filter?: ModelSubscriptionReviewFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteReviewSubscription = {
  onDeleteReview?:  {
    __typename: "Review",
    accountId: string,
    archived?: boolean | null,
    baseSnapId?: string | null,
    checklist?: string | null,
    createdAt?: string | null,
    id: string,
    managed?: boolean | null,
    modelId: string,
    ownerId: string,
    reviewDate?: string | null,
    snapshotId?: string | null,
    status?: string | null,
    submittedOn?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnDeleteSessionSubscriptionVariables = {
  filter?: ModelSubscriptionSessionFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteSessionSubscription = {
  onDeleteSession?:  {
    __typename: "Session",
    accountId: string,
    createdAt?: string | null,
    duration?: number | null,
    id: string,
    ownerId: string,
    sessionDate?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnDeleteSnapshotSubscriptionVariables = {
  filter?: ModelSubscriptionSnapshotFilterInput | null,
  userId?: string | null,
};

export type OnDeleteSnapshotSubscription = {
  onDeleteSnapshot?:  {
    __typename: "Snapshot",
    accountId: string,
    archived?: boolean | null,
    createdAt?: string | null,
    date: string,
    description?: string | null,
    details?: string | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    snapshotType?: SnapshotType | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteTaxSubscriptionVariables = {
  filter?: ModelSubscriptionTaxFilterInput | null,
  userId?: string | null,
};

export type OnDeleteTaxSubscription = {
  onDeleteTax?:  {
    __typename: "Tax",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    taxType?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteTaxValueSubscriptionVariables = {
  filter?: ModelSubscriptionTaxValueFilterInput | null,
  userId?: string | null,
};

export type OnDeleteTaxValueSubscription = {
  onDeleteTaxValue?:  {
    __typename: "TaxValue",
    accountId: string,
    createdAt?: string | null,
    id: string,
    key: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
    value: number,
    year: number,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    account?:  {
      __typename: "Account",
      address?: string | null,
      city?: string | null,
      createdAt?: string | null,
      id: string,
      name: string,
      ownerId?: string | null,
      postalCode?: string | null,
      state?: string | null,
      updatedAt?: string | null,
    } | null,
    accountId: string,
    advisorAccess?: boolean | null,
    advisorModelId?: string | null,
    advisorPrimaryModelId?: string | null,
    cancelledOn?: string | null,
    clientOn?: string | null,
    createdAt?: string | null,
    currentModelId?: string | null,
    currentPlanId?: string | null,
    customerId?: string | null,
    deletedOn?: string | null,
    deletedReason?: string | null,
    email: string,
    emailVerified?: boolean | null,
    endDate?: string | null,
    firstName: string,
    id: string,
    lastAccess?: string | null,
    lastName: string,
    mfaPreference?: string | null,
    migrateStatus?: string | null,
    migratedOn?: string | null,
    models?:  {
      __typename: "ModelModelConnection",
      nextToken?: string | null,
    } | null,
    phone?: string | null,
    phoneVerified?: boolean | null,
    primaryModelId?: string | null,
    referrer?: string | null,
    referrerDetails?: string | null,
    reviews?:  {
      __typename: "ModelReviewConnection",
      nextToken?: string | null,
    } | null,
    role: UserRole,
    sessionCount?: number | null,
    sessions?:  {
      __typename: "ModelSessionConnection",
      nextToken?: string | null,
    } | null,
    settings?:  {
      __typename: "ModelUserSettingConnection",
      nextToken?: string | null,
    } | null,
    startDate?: string | null,
    subscribedOn?: string | null,
    trialEndDate?: string | null,
    updatedAt?: string | null,
    userStatus: UserStatus,
    userType: UserType,
  } | null,
};

export type OnDeleteUserInviteSubscriptionVariables = {
  filter?: ModelSubscriptionUserInviteFilterInput | null,
  userId?: string | null,
};

export type OnDeleteUserInviteSubscription = {
  onDeleteUserInvite?:  {
    __typename: "UserInvite",
    accountId: string,
    createdAt?: string | null,
    email: string,
    firstName: string,
    id: string,
    invitedOn: string,
    lastName: string,
    role: UserRole,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnDeleteUserSettingSubscriptionVariables = {
  filter?: ModelSubscriptionUserSettingFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteUserSettingSubscription = {
  onDeleteUserSetting?:  {
    __typename: "UserSetting",
    accountId: string,
    createdAt?: string | null,
    description?: string | null,
    id: string,
    name: string,
    ownerId: string,
    settingType?: string | null,
    settings?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnUpdateAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateAccountSubscription = {
  onUpdateAccount?:  {
    __typename: "Account",
    address?: string | null,
    city?: string | null,
    createdAt?: string | null,
    id: string,
    name: string,
    ownerId?: string | null,
    postalCode?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    users?:  {
      __typename: "ModelUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateAssetSubscriptionVariables = {
  filter?: ModelSubscriptionAssetFilterInput | null,
  userId?: string | null,
};

export type OnUpdateAssetSubscription = {
  onUpdateAsset?:  {
    __typename: "Asset",
    accountId: string,
    archived?: boolean | null,
    assetCategory?: number | null,
    assetIncome?:  {
      __typename: "AssetIncome",
      basis?: number | null,
      rateTotal?: number | null,
      units?: number | null,
    } | null,
    assetIncomeDate?: string | null,
    assetType?: number | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    inheritedYear?: number | null,
    managed?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    netWorthExcluded?: boolean | null,
    notes?: string | null,
    originalOwnerBirthYear?: number | null,
    ownerId?: string | null,
    priorEoYBalance?: number | null,
    rateLock?: boolean | null,
    returnRate?: number | null,
    risk?: number | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
    withdrawalOrder?: number | null,
    withdrawalsYTD?: number | null,
  } | null,
};

export type OnUpdateAssetCategorySubscriptionVariables = {
  filter?: ModelSubscriptionAssetCategoryFilterInput | null,
};

export type OnUpdateAssetCategorySubscription = {
  onUpdateAssetCategory?:  {
    __typename: "AssetCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateAssetConversionSubscriptionVariables = {
  filter?: ModelSubscriptionAssetConversionFilterInput | null,
  userId?: string | null,
};

export type OnUpdateAssetConversionSubscription = {
  onUpdateAssetConversion?:  {
    __typename: "AssetConversion",
    accountId: string,
    amount?: number | null,
    archived?: boolean | null,
    completedAt?: string | null,
    conversionType?: string | null,
    createdAt?: string | null,
    description?: string | null,
    dstAssetId: string,
    id: string,
    incomeType?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nonTaxableAmount?: number | null,
    percent?: number | null,
    sortOrder?: number | null,
    srcAssetId: string,
    taxableAmount?: number | null,
    updatedAt?: string | null,
    userId: string,
    year?: number | null,
  } | null,
};

export type OnUpdateAssetTypeSubscriptionVariables = {
  filter?: ModelSubscriptionAssetTypeFilterInput | null,
};

export type OnUpdateAssetTypeSubscription = {
  onUpdateAssetType?:  {
    __typename: "AssetType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateDeductionSubscriptionVariables = {
  filter?: ModelSubscriptionDeductionFilterInput | null,
  userId?: string | null,
};

export type OnUpdateDeductionSubscription = {
  onUpdateDeduction?:  {
    __typename: "Deduction",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    deductionType?: number | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateExpenseSubscriptionVariables = {
  filter?: ModelSubscriptionExpenseFilterInput | null,
  userId?: string | null,
};

export type OnUpdateExpenseSubscription = {
  onUpdateExpense?:  {
    __typename: "Expense",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    discretionary?: boolean | null,
    end?: string | null,
    endDate?: string | null,
    expenseCategory?: number | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    liabilityId?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateExpenseCategorySubscriptionVariables = {
  filter?: ModelSubscriptionExpenseCategoryFilterInput | null,
};

export type OnUpdateExpenseCategorySubscription = {
  onUpdateExpenseCategory?:  {
    __typename: "ExpenseCategory",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    sortOrder?: number | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateIncomeSubscriptionVariables = {
  filter?: ModelSubscriptionIncomeFilterInput | null,
  userId?: string | null,
};

export type OnUpdateIncomeSubscription = {
  onUpdateIncome?:  {
    __typename: "Income",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    assetId?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    excludeFromNIIT?: boolean | null,
    grossAmount?: number | null,
    id: string,
    imputed?: boolean | null,
    incomeType?: number | null,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    survivorPercent?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateIncomeTypeSubscriptionVariables = {
  filter?: ModelSubscriptionIncomeTypeFilterInput | null,
};

export type OnUpdateIncomeTypeSubscription = {
  onUpdateIncomeType?:  {
    __typename: "IncomeType",
    createdAt?: string | null,
    description?: string | null,
    id: string,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateLiabilitySubscriptionVariables = {
  filter?: ModelSubscriptionLiabilityFilterInput | null,
  userId?: string | null,
};

export type OnUpdateLiabilitySubscription = {
  onUpdateLiability?:  {
    __typename: "Liability",
    accountId: string,
    archived?: boolean | null,
    balance?: number | null,
    balanceDate?: string | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    interestRate?: number | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    payoffDate?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateMilestoneSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneFilterInput | null,
  userId?: string | null,
};

export type OnUpdateMilestoneSubscription = {
  onUpdateMilestone?:  {
    __typename: "Milestone",
    accountId: string,
    age?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    date?: string | null,
    description?: string | null,
    id: string,
    label?: string | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateModelSubscriptionVariables = {
  filter?: ModelSubscriptionModelFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateModelSubscription = {
  onUpdateModel?:  {
    __typename: "Model",
    accountId: string,
    advisorCreated?: boolean | null,
    archived?: boolean | null,
    assetConversions?:  {
      __typename: "ModelAssetConversionConnection",
      nextToken?: string | null,
    } | null,
    assets?:  {
      __typename: "ModelAssetConnection",
      nextToken?: string | null,
    } | null,
    clientAccess?: ClientAccess | null,
    createdAt?: string | null,
    deductions?:  {
      __typename: "ModelDeductionConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    expenses?:  {
      __typename: "ModelExpenseConnection",
      nextToken?: string | null,
    } | null,
    id: string,
    incomes?:  {
      __typename: "ModelIncomeConnection",
      nextToken?: string | null,
    } | null,
    liabilities?:  {
      __typename: "ModelLiabilityConnection",
      nextToken?: string | null,
    } | null,
    milestones?:  {
      __typename: "ModelMilestoneConnection",
      nextToken?: string | null,
    } | null,
    name: string,
    ownerId: string,
    persons?:  {
      __typename: "ModelPersonConnection",
      nextToken?: string | null,
    } | null,
    plans?:  {
      __typename: "ModelPlanConnection",
      nextToken?: string | null,
    } | null,
    settings?: string | null,
    snapshots?:  {
      __typename: "ModelSnapshotConnection",
      nextToken?: string | null,
    } | null,
    startedAt?: string | null,
    taxValues?:  {
      __typename: "ModelTaxValueConnection",
      nextToken?: string | null,
    } | null,
    taxes?:  {
      __typename: "ModelTaxConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    updatedBy?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnUpdatePersonSubscriptionVariables = {
  filter?: ModelSubscriptionPersonFilterInput | null,
  userId?: string | null,
};

export type OnUpdatePersonSubscription = {
  onUpdatePerson?:  {
    __typename: "Person",
    accountId: string,
    birthDate?: string | null,
    createdAt?: string | null,
    gender?: Gender | null,
    hereditaryAdjust?: number | null,
    id: string,
    lifeExpectancy?: number | null,
    maritalStatus?: MaritalStatus | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    nickname?: string | null,
    retireDate?: string | null,
    state?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdatePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
  userId?: string | null,
};

export type OnUpdatePlanSubscription = {
  onUpdatePlan?:  {
    __typename: "Plan",
    accountId: string,
    archived?: boolean | null,
    changes?:  {
      __typename: "ModelPlanChangeConnection",
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    default?: boolean | null,
    description?: string | null,
    enabled?: boolean | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    name?: string | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdatePlanChangeSubscriptionVariables = {
  filter?: ModelSubscriptionPlanChangeFilterInput | null,
  userId?: string | null,
};

export type OnUpdatePlanChangeSubscription = {
  onUpdatePlanChange?:  {
    __typename: "PlanChange",
    accountId: string,
    changeType: string,
    createdAt?: string | null,
    description?: string | null,
    details?: string | null,
    enabled?: boolean | null,
    id: string,
    modelId: string,
    name: string,
    plan?:  {
      __typename: "Plan",
      accountId: string,
      archived?: boolean | null,
      createdAt?: string | null,
      default?: boolean | null,
      description?: string | null,
      enabled?: boolean | null,
      id: string,
      modelId: string,
      name?: string | null,
      updatedAt?: string | null,
      userId: string,
    } | null,
    planId: string,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateReviewSubscriptionVariables = {
  filter?: ModelSubscriptionReviewFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateReviewSubscription = {
  onUpdateReview?:  {
    __typename: "Review",
    accountId: string,
    archived?: boolean | null,
    baseSnapId?: string | null,
    checklist?: string | null,
    createdAt?: string | null,
    id: string,
    managed?: boolean | null,
    modelId: string,
    ownerId: string,
    reviewDate?: string | null,
    snapshotId?: string | null,
    status?: string | null,
    submittedOn?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnUpdateSessionSubscriptionVariables = {
  filter?: ModelSubscriptionSessionFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateSessionSubscription = {
  onUpdateSession?:  {
    __typename: "Session",
    accountId: string,
    createdAt?: string | null,
    duration?: number | null,
    id: string,
    ownerId: string,
    sessionDate?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};

export type OnUpdateSnapshotSubscriptionVariables = {
  filter?: ModelSubscriptionSnapshotFilterInput | null,
  userId?: string | null,
};

export type OnUpdateSnapshotSubscription = {
  onUpdateSnapshot?:  {
    __typename: "Snapshot",
    accountId: string,
    archived?: boolean | null,
    createdAt?: string | null,
    date: string,
    description?: string | null,
    details?: string | null,
    id: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    snapshotType?: SnapshotType | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateTaxSubscriptionVariables = {
  filter?: ModelSubscriptionTaxFilterInput | null,
  userId?: string | null,
};

export type OnUpdateTaxSubscription = {
  onUpdateTax?:  {
    __typename: "Tax",
    accountId: string,
    amount?: number | null,
    amountDate?: string | null,
    annualInf?: number | null,
    archived?: boolean | null,
    createdAt?: string | null,
    description?: string | null,
    end?: string | null,
    endDate?: string | null,
    id: string,
    infAdjust?: boolean | null,
    infLock?: boolean | null,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    ownerId?: string | null,
    paycheckId?: string | null,
    schedule?: string | null,
    sortOrder?: number | null,
    start?: string | null,
    startDate?: string | null,
    taxType?: number | null,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateTaxValueSubscriptionVariables = {
  filter?: ModelSubscriptionTaxValueFilterInput | null,
  userId?: string | null,
};

export type OnUpdateTaxValueSubscription = {
  onUpdateTaxValue?:  {
    __typename: "TaxValue",
    accountId: string,
    createdAt?: string | null,
    id: string,
    key: string,
    model?:  {
      __typename: "Model",
      accountId: string,
      advisorCreated?: boolean | null,
      archived?: boolean | null,
      clientAccess?: ClientAccess | null,
      createdAt?: string | null,
      description?: string | null,
      id: string,
      name: string,
      ownerId: string,
      settings?: string | null,
      startedAt?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      userId: string,
    } | null,
    modelId: string,
    updatedAt?: string | null,
    userId: string,
    value: number,
    year: number,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    account?:  {
      __typename: "Account",
      address?: string | null,
      city?: string | null,
      createdAt?: string | null,
      id: string,
      name: string,
      ownerId?: string | null,
      postalCode?: string | null,
      state?: string | null,
      updatedAt?: string | null,
    } | null,
    accountId: string,
    advisorAccess?: boolean | null,
    advisorModelId?: string | null,
    advisorPrimaryModelId?: string | null,
    cancelledOn?: string | null,
    clientOn?: string | null,
    createdAt?: string | null,
    currentModelId?: string | null,
    currentPlanId?: string | null,
    customerId?: string | null,
    deletedOn?: string | null,
    deletedReason?: string | null,
    email: string,
    emailVerified?: boolean | null,
    endDate?: string | null,
    firstName: string,
    id: string,
    lastAccess?: string | null,
    lastName: string,
    mfaPreference?: string | null,
    migrateStatus?: string | null,
    migratedOn?: string | null,
    models?:  {
      __typename: "ModelModelConnection",
      nextToken?: string | null,
    } | null,
    phone?: string | null,
    phoneVerified?: boolean | null,
    primaryModelId?: string | null,
    referrer?: string | null,
    referrerDetails?: string | null,
    reviews?:  {
      __typename: "ModelReviewConnection",
      nextToken?: string | null,
    } | null,
    role: UserRole,
    sessionCount?: number | null,
    sessions?:  {
      __typename: "ModelSessionConnection",
      nextToken?: string | null,
    } | null,
    settings?:  {
      __typename: "ModelUserSettingConnection",
      nextToken?: string | null,
    } | null,
    startDate?: string | null,
    subscribedOn?: string | null,
    trialEndDate?: string | null,
    updatedAt?: string | null,
    userStatus: UserStatus,
    userType: UserType,
  } | null,
};

export type OnUpdateUserInviteSubscriptionVariables = {
  filter?: ModelSubscriptionUserInviteFilterInput | null,
  userId?: string | null,
};

export type OnUpdateUserInviteSubscription = {
  onUpdateUserInvite?:  {
    __typename: "UserInvite",
    accountId: string,
    createdAt?: string | null,
    email: string,
    firstName: string,
    id: string,
    invitedOn: string,
    lastName: string,
    role: UserRole,
    updatedAt?: string | null,
    userId: string,
  } | null,
};

export type OnUpdateUserSettingSubscriptionVariables = {
  filter?: ModelSubscriptionUserSettingFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateUserSettingSubscription = {
  onUpdateUserSetting?:  {
    __typename: "UserSetting",
    accountId: string,
    createdAt?: string | null,
    description?: string | null,
    id: string,
    name: string,
    ownerId: string,
    settingType?: string | null,
    settings?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "User",
      accountId: string,
      advisorAccess?: boolean | null,
      advisorModelId?: string | null,
      advisorPrimaryModelId?: string | null,
      cancelledOn?: string | null,
      clientOn?: string | null,
      createdAt?: string | null,
      currentModelId?: string | null,
      currentPlanId?: string | null,
      customerId?: string | null,
      deletedOn?: string | null,
      deletedReason?: string | null,
      email: string,
      emailVerified?: boolean | null,
      endDate?: string | null,
      firstName: string,
      id: string,
      lastAccess?: string | null,
      lastName: string,
      mfaPreference?: string | null,
      migrateStatus?: string | null,
      migratedOn?: string | null,
      phone?: string | null,
      phoneVerified?: boolean | null,
      primaryModelId?: string | null,
      referrer?: string | null,
      referrerDetails?: string | null,
      role: UserRole,
      sessionCount?: number | null,
      startDate?: string | null,
      subscribedOn?: string | null,
      trialEndDate?: string | null,
      updatedAt?: string | null,
      userStatus: UserStatus,
      userType: UserType,
    } | null,
    userId: string,
  } | null,
};
